"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconTypes = exports.Icon = exports.CaretLeft = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _components = require("./components");
var _utils = require("./utils");
var _excluded = ["type", "className", "size"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
/**
 * TODO: Lingering design questions
 * - Revisit code organization and how types are categorized into sub-components
 *   (e.g. Arrow and Caret)
 * - Potentially hard-code any semantic colors such as for Alert, Success, Info
 * - Is each variation of an icon having its own type good API or
 *   should some variation be controlled through props, such as size?
 */

/**
 * To add SVGs:
 * - Paste the raw SVG code into here first: https://jakearchibald.github.io/svgomg/
 * - Copy the generated code into this file and edit it to look like the other SVG attributes.
 * - Remove any attributes related to styling so they can be controlled by Tailwind classes instead.
 *   Please refer to the note about fill and stroke attributes.
 * - Make sure to add the type to IconType.
 *
 * Based on this tutorial https://www.youtube.com/watch?v=MbUyHQRq2go
 *
 * NOTE: Specifying the `viewBoxSize` prop is important for maintaining
 * the icon's aspect ratio when resizing it with the `size` prop.
 * Ensure that the viewBoxSize is the same as specified in the original <svg> element.
 * For example, if the raw SVG has <svg viewBox="0 0 24 24" ...>
 * ensure that the Icon renders <BaseSvg viewBoxSize={24} .../>
 *
 * NOTE: Want an icon that can have a color that is variable at runtime?
 * 1. In the raw SVG, check whether the color is being applied via fill, stroke, or both.
 *    For example, if the SVG contains a <path stroke="#325971"/>, then it is being applied via stroke.
 *    If it contains a <path fill="#325971"/>, then it is being applied via fill.
 * 2. Add the Tailwind class 'fill-current', 'stroke-current', or both to the BaseSVG className.
 * 3. Remove the "fill" and "stroke" attributes from any <path>s.
 *    NOTE: If a <path> element inside a <mask> element has fill='#fff', don't remove that
 *    attribute because the path fill helps determine the shape of the mask.
 *    NOTE: If the BaseSVG only has 'stroke-current' applied and not 'fill-current',
 *    the BaseSVG will also need fill="none" to override the SVG's default black fill.
 * 4. Ensure the Icon has a text color that is your desired fill color.
 *    Ex: <Icon className="text-orange1-30" type="MonumentLogo" />
 */

var IconTypes = [].concat(_toConsumableArray(_components.CaretTypes), _toConsumableArray(_components.ArrowTypes), ['add-heavy-16', 'add-heavy-24', 'add-regular-24', 'alert-filled', 'alert-indicator', 'alert', 'appointments', 'availability', 'beer-can', 'beer-mug', 'billing-sheet-circles-lines', 'book-learn', 'calendar-plus', 'calendar', 'camera-off', 'camera-on', 'camera', 'chart-add', 'chat-bubble-question-mark', 'chat', 'check-16', 'check-24', 'check-heavy-16', 'clinician-menu', 'close-16', 'close-24', 'close-bubble-filled', 'close-bubble-no-bubble', 'close-bubble', 'cloud-active', 'cloud-inactive', 'cocktail', 'download', 'drugs-pill-add-plus', 'edit-pencil-filled', 'edit-pencil', 'ellipse', 'employees', 'enter', 'exit', 'favorite', 'filter-16', 'filter-24', 'fullscreen-exit', 'fullscreen', 'green-dot', 'groups-filled', 'groups-heads', 'groups-menu', 'groups', 'hash', 'heart-check', 'hide-password', 'home-filled', 'home', 'info-filled', 'info', 'instagram', 'insurance-hands-heart', 'insurance', 'leave-call', 'library-add-check', 'location-pin', 'lock', 'logout', 'mail', 'medical-cross-in-rounded-square', 'menu-circle', 'menu-small', 'menu', 'message-letter', 'microphone-off', 'microphone-on', 'monument-logo', 'more-16', 'more-24', 'more-filled-16', 'more-filled-24', 'my-care-filled', 'my-care', 'notification-bell', 'payment-card', 'pen', 'playlist', 'profile-circle', 'profile-rounded-square', 'protection-shield', 'reschedule', 'resources-filled', 'resources', 'reviews-in-circle', 'reviews-menu', 'reviews', 'schedule', 'screenshare-off', 'screenshare-on', 'search-16', 'search-24', 'session-notes', 'settings-redesign', 'settings', 'share', 'shield', 'show-password', 'sound-mute', 'sound', 'sprout', 'star', 'subtract-heavy-16', 'subtract-light-24', 'success-16', 'success-24', 'success-filled-24', 'templates', 'video-bell', 'white-dot', 'wineglass']);
exports.IconTypes = IconTypes;
var CaretLeft = function CaretLeft(_ref) {
  var _ref$viewBox = _ref.viewBox,
    viewBox = _ref$viewBox === void 0 ? '0 0 16 14' : _ref$viewBox,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'fill-green1-55 h-[14px] w-[14px]' : _ref$className;
  return /*#__PURE__*/_react.default.createElement("svg", {
    viewBox: viewBox,
    className: className
  }, /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.7439 12.5662C8.02618 12.8351 8.08264 13.3279 7.87563 13.6752C7.75331 13.8768 7.55571 14 7.34871 14C7.20757 14 7.06643 13.944 6.95351 13.8432L0.263462 7.62644C0.0940935 7.46962 0 7.24559 0 6.98796C0 6.74153 0.0940935 6.5063 0.263462 6.36069L6.95351 0.166345C7.08524 0.031929 7.25461 -0.0240777 7.43339 0.0095263C7.61217 0.031929 7.76272 0.143942 7.87563 0.323164C8.08264 0.670405 8.02618 1.17447 7.7439 1.4321L1.73132 6.98796L7.7439 12.5662Z"
  }));
};

/**
 * When specifying the color of an icon, do so through text color
 */
exports.CaretLeft = CaretLeft;
var Icon = function Icon(_ref2) {
  var type = _ref2.type,
    className = _ref2.className,
    size = _ref2.size,
    props = _objectWithoutProperties(_ref2, _excluded);
  if (type.includes('caret')) {
    return /*#__PURE__*/_react.default.createElement(_components.Caret, _extends({
      type: type,
      className: (0, _classnames.default)(className),
      size: size
    }, props));
  }
  if (type.includes('arrow')) {
    return /*#__PURE__*/_react.default.createElement(_components.Arrow, _extends({
      type: type,
      className: (0, _classnames.default)(className),
      size: size
    }, props));
  }
  switch (type) {
    case 'check-16':
      {
        return /*#__PURE__*/_react.default.createElement(_components.BaseSvg, _extends({
          size: size,
          viewBoxSize: 16,
          className: (0, _classnames.default)('fill-current', className)
        }, props), /*#__PURE__*/_react.default.createElement("path", {
          d: "M12.472 3.315a.874.874 0 011.205-.134c.341.265.42.732.198 1.085l-.061.086-6.82 8.334a.874.874 0 01-1.222.118l-.075-.069-3.466-3.61a.817.817 0 01.041-1.178.876.876 0 011.134-.032l.078.072 2.787 2.904 6.201-7.576z"
        }));
      }
    case 'success-16':
      {
        return /*#__PURE__*/_react.default.createElement(_components.BaseSvg, _extends({
          size: size,
          viewBoxSize: 16,
          className: (0, _classnames.default)('fill-current stroke-current', className)
        }, props), /*#__PURE__*/_react.default.createElement("circle", {
          cx: "8",
          cy: "8",
          r: "7.5",
          fillOpacity: "0"
        }), /*#__PURE__*/_react.default.createElement("path", {
          strokeOpacity: "0",
          d: "M10.981 5.201a.6.6 0 01.803-.085.51.51 0 01.133.694l-.041.055L7.33 11.2a.6.6 0 01-.815.076l-.05-.044L4.154 8.92a.509.509 0 01.028-.754.602.602 0 01.755-.02l.052.046 1.858 1.858 4.134-4.849z"
        }));
      }
    case 'check-24':
      {
        return /*#__PURE__*/_react.default.createElement(_components.BaseSvg, _extends({
          size: size,
          viewBoxSize: 24,
          className: (0, _classnames.default)('fill-current', className)
        }, props), /*#__PURE__*/_react.default.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M18.708 5.44c.442-.504 1.251-.588 1.807-.186.512.37.63 1.024.298 1.519l-.092.12L10.49 18.56c-.456.52-1.289.583-1.833.167l-.113-.097-5.2-5.056c-.484-.47-.456-1.209.063-1.649a1.387 1.387 0 011.7-.044l.118.101 4.18 4.065L18.708 5.44z"
        }));
      }
    case 'success-24':
      {
        return /*#__PURE__*/_react.default.createElement(_components.BaseSvg, _extends({
          size: size,
          viewBoxSize: 24,
          className: (0, _classnames.default)('fill-current', className)
        }, props), /*#__PURE__*/_react.default.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12 3.364c-4.762 0-8.636 3.874-8.636 8.636 0 4.762 3.874 8.636 8.636 8.636 4.762 0 8.636-3.874 8.636-8.636 0-4.762-3.874-8.636-8.636-8.636zM12 22C6.486 22 2 17.514 2 12S6.486 2 12 2s10 4.486 10 10-4.486 10-10 10z"
        }), /*#__PURE__*/_react.default.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M16.066 7.74a.794.794 0 011.095-.12c.31.24.382.664.18.986l-.055.078-6.2 7.576a.794.794 0 01-1.11.108l-.069-.063-3.152-3.283a.744.744 0 01.038-1.07.796.796 0 011.031-.029l.071.066 2.534 2.639 5.637-6.888z"
        }));
      }
    case 'success-filled-24':
      {
        return /*#__PURE__*/_react.default.createElement(_components.BaseSvg, _extends({
          size: size,
          viewBoxSize: 24,
          className: (0, _classnames.default)('fill-current', className)
        }, props), /*#__PURE__*/_react.default.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M17.336 8.61l-.055.072-6.2 7.582a.792.792 0 01-1.11.1l-.072-.055-3.145-3.29c-.3-.3-.281-.783.036-1.065a.787.787 0 011.027-.027l.073.064 2.536 2.636 5.638-6.89a.786.786 0 011.09-.119.744.744 0 01.182.991zM12 2C6.482 2 2 6.482 2 12s4.482 10 10 10c5.508 0 10-4.482 10-10S17.508 2 12 2z"
        }));
      }
    case 'check-heavy-16':
      {
        return /*#__PURE__*/_react.default.createElement(_components.BaseSvg, _extends({
          size: size,
          viewBoxSize: 16,
          className: (0, _classnames.default)('fill-current', className)
        }, props), /*#__PURE__*/_react.default.createElement("path", {
          d: "M12.311 3.347a.968.968 0 011.331-.147.9.9 0 01.216 1.202l-.064.088-6.7 8.163a.968.968 0 01-1.35.131l-.083-.076-3.406-3.537A.899.899 0 012.3 7.873a.97.97 0 011.259-.03l.08.075 2.655 2.758 6.016-7.33z"
        }));
      }
    case 'add-heavy-16':
      {
        return /*#__PURE__*/_react.default.createElement(_components.BaseSvg, _extends({
          size: size,
          viewBoxSize: 16,
          className: (0, _classnames.default)('fill-current', className)
        }, props), /*#__PURE__*/_react.default.createElement("path", {
          d: "M7.86 1.013L8 1c.382 0 .7.275.765.638l.013.14v5.444h5.444c.382 0 .7.275.766.638L15 8c0 .382-.275.7-.638.765l-.14.013H8.778v5.444c0 .382-.275.7-.638.766L8 15a.778.778 0 01-.765-.638l-.013-.14V8.778H1.778a.778.778 0 01-.765-.638L1 8c0-.382.275-.7.638-.765l.14-.013h5.444V1.778c0-.382.275-.7.638-.765z"
        }));
      }
    case 'add-regular-24':
      {
        return /*#__PURE__*/_react.default.createElement(_components.BaseSvg, _extends({
          size: size,
          viewBoxSize: 24,
          className: (0, _classnames.default)('fill-current', className)
        }, props), /*#__PURE__*/_react.default.createElement("path", {
          d: "M11.524 21.546c0 .25.213.454.476.454a.466.466 0 00.476-.454V12h9.048a.466.466 0 00.476-.454.466.466 0 00-.476-.455h-9.048V2.455A.466.466 0 0012 2a.466.466 0 00-.476.455v8.636H2.476a.466.466 0 00-.476.455c0 .25.213.454.476.454h9.048v9.546z"
        }));
      }
    case 'add-heavy-24':
      {
        return /*#__PURE__*/_react.default.createElement(_components.BaseSvg, _extends({
          size: size,
          viewBoxSize: 24,
          className: (0, _classnames.default)('fill-current', className)
        }, props), /*#__PURE__*/_react.default.createElement("path", {
          d: "M11.8 2.018L12 2c.546 0 1 .393 1.093.911l.018.2v7.778h7.778c.545 0 .999.393 1.093.911L22 12c0 .546-.393 1-.911 1.093l-.2.018H13.11v7.778c0 .545-.393.999-.911 1.093L12 22c-.546 0-1-.393-1.093-.911l-.018-.2V13.11H3.11c-.545 0-.999-.393-1.093-.911L2 12c0-.546.393-1 .911-1.093l.2-.018h7.778V3.11c0-.545.393-.999.911-1.093L12 2l-.2.018z"
        }));
      }
    case 'more-16':
      {
        return /*#__PURE__*/_react.default.createElement(_components.BaseSvg, _extends({
          size: size,
          viewBoxSize: 16,
          className: (0, _classnames.default)('fill-current', className)
        }, props), /*#__PURE__*/_react.default.createElement("mask", {
          id: "a",
          maskUnits: "userSpaceOnUse",
          x: "0",
          y: "0",
          width: "16",
          height: "16"
        }, /*#__PURE__*/_react.default.createElement("path", {
          d: "M0 0h16v16H0V0z",
          fill: "#fff"
        })), /*#__PURE__*/_react.default.createElement("g", {
          mask: "url(#a)"
        }, /*#__PURE__*/_react.default.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M8 0a8 8 0 100 16A8 8 0 008 0zm0 1c3.86 0 7 3.14 7 7s-3.14 7-7 7-7-3.14-7-7 3.14-7 7-7z"
        })), /*#__PURE__*/_react.default.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M8.553 12.541c0 .312-.24.552-.551.552a.523.523 0 01-.396-.155.522.522 0 01-.156-.397V8.553l-3.995-.007a.522.522 0 01-.396-.155.522.522 0 01-.155-.396c-.001-.142.056-.283.162-.39a.548.548 0 01.39-.162h3.987V3.455a.574.574 0 01.559-.558.552.552 0 01.551.551l.007 3.995h3.989a.552.552 0 01.551.552.555.555 0 01-.559.558H8.553v3.988z"
        }));
      }
    case 'more-filled-16':
      {
        return /*#__PURE__*/_react.default.createElement(_components.BaseSvg, _extends({
          size: size,
          viewBoxSize: 16,
          className: (0, _classnames.default)('fill-current', className)
        }, props), /*#__PURE__*/_react.default.createElement("mask", {
          id: "a",
          maskUnits: "userSpaceOnUse",
          x: "0",
          y: "0",
          width: "16",
          height: "16"
        }, /*#__PURE__*/_react.default.createElement("path", {
          d: "M0 0h16v16H0V0z",
          fill: "#fff"
        })), /*#__PURE__*/_react.default.createElement("g", {
          mask: "url(#a)"
        }, /*#__PURE__*/_react.default.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12.45 8.54H8.54v3.91c0 .31-.23.54-.54.54a.54.54 0 01-.39-.15.547.547 0 01-.15-.39V8.54l-3.92-.01a.5.5 0 01-.38-.15.546.546 0 010-.771.587.587 0 01.38-.159h3.92V3.54c0-.3.25-.55.54-.55.14 0 .28.06.38.16.11.11.16.24.16.38l.01 3.92h3.91c.14 0 .28.06.38.16a.51.51 0 01.16.38c0 .31-.24.55-.55.55zM8 0C3.58 0 0 3.58 0 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8z"
        })));
      }
    case 'more-24':
      {
        return /*#__PURE__*/_react.default.createElement(_components.BaseSvg, _extends({
          size: size,
          viewBoxSize: 24,
          className: (0, _classnames.default)('fill-current', className)
        }, props), /*#__PURE__*/_react.default.createElement("mask", {
          id: "a",
          maskUnits: "userSpaceOnUse",
          x: "0",
          y: "0",
          width: "24",
          height: "24"
        }, /*#__PURE__*/_react.default.createElement("path", {
          d: "M0 0h24v24H0V0z",
          fill: "#fff"
        })), /*#__PURE__*/_react.default.createElement("g", {
          mask: "url(#a)"
        }, /*#__PURE__*/_react.default.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12 0C5.372 0 0 5.373 0 12c0 6.628 5.372 12 12 12 6.627 0 12-5.372 12-12 0-6.627-5.373-12-12-12zm0 1.35c5.872 0 10.65 4.778 10.65 10.65 0 5.873-4.778 10.65-10.65 10.65-5.873 0-10.65-4.777-10.65-10.65C1.35 6.128 6.127 1.35 12 1.35z"
        })), /*#__PURE__*/_react.default.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M19 12c0 .38-.308.678-.678.678h-5.645v5.645a.677.677 0 01-1.355 0v-5.645H5.677a.676.676 0 110-1.355h5.645V5.678c0-.37.308-.678.678-.678.37 0 .677.308.677.678v5.645h5.645c.37 0 .678.307.678.677z"
        }));
      }
    case 'more-filled-24':
      {
        return /*#__PURE__*/_react.default.createElement(_components.BaseSvg, _extends({
          size: size,
          viewBoxSize: 24,
          className: (0, _classnames.default)('fill-current', className)
        }, props), /*#__PURE__*/_react.default.createElement("mask", {
          id: "a",
          maskUnits: "userSpaceOnUse",
          x: "0",
          y: "0",
          width: "24",
          height: "24"
        }, /*#__PURE__*/_react.default.createElement("path", {
          d: "M0 0h24v24H0V0z",
          fill: "#fff"
        })), /*#__PURE__*/_react.default.createElement("g", {
          mask: "url(#a)"
        }, /*#__PURE__*/_react.default.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M18.32 12.67h-5.65v5.65c0 .38-.3.68-.67.68-.37 0-.68-.3-.68-.68v-5.65H5.67A.664.664 0 015 12c0-.37.3-.68.67-.68h5.65V5.67c0-.37.31-.67.68-.67.37 0 .67.3.67.67v5.65h5.65c.37 0 .68.31.68.68 0 .38-.31.67-.68.67zM12 0C5.37 0 0 5.37 0 12c0 6.62 5.37 12 12 12 6.62 0 12-5.38 12-12 0-6.63-5.38-12-12-12z"
        })));
      }
    case 'subtract-heavy-16':
      {
        return /*#__PURE__*/_react.default.createElement(_components.BaseSvg, _extends({
          size: size,
          viewBoxSize: 16,
          className: (0, _classnames.default)('fill-current', className)
        }, props), /*#__PURE__*/_react.default.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M1 7.75A.75.75 0 011.75 7h12.5a.75.75 0 010 1.5H1.75A.75.75 0 011 7.75z"
        }));
      }
    case 'subtract-light-24':
      {
        return /*#__PURE__*/_react.default.createElement(_components.BaseSvg, _extends({
          size: size,
          viewBoxSize: 24,
          className: (0, _classnames.default)('fill-current', className)
        }, props), /*#__PURE__*/_react.default.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M2 12c0-.276.204-.5.455-.5h19.09c.252 0 .455.224.455.5s-.203.5-.454.5H2.454C2.204 12.5 2 12.276 2 12z"
        }));
      }
    case 'menu':
      {
        return /*#__PURE__*/_react.default.createElement(_components.BaseSvg, _extends({
          size: size,
          viewBoxSize: 16,
          className: (0, _classnames.default)('fill-current', className)
        }, props), /*#__PURE__*/_react.default.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M.556 4a.556.556 0 000 1.111h14.888a.556.556 0 100-1.111H.556zM0 9c0-.307.249-.556.556-.556h14.888a.556.556 0 110 1.112H.556A.556.556 0 010 9zm0 4.444c0-.306.249-.555.556-.555h14.888a.556.556 0 110 1.111H.556A.556.556 0 010 13.444z"
        }));
      }
    case 'menu-circle':
      {
        return /*#__PURE__*/_react.default.createElement(_components.BaseSvg, _extends({
          size: size,
          viewBoxSize: 32,
          fill: "none",
          className: (0, _classnames.default)('stroke-current', className)
        }, props), /*#__PURE__*/_react.default.createElement("path", {
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "1.5",
          d: "M24.486 7.515c4.686 4.686 4.686 12.284 0 16.97-4.687 4.687-12.284 4.687-16.971 0-4.687-4.686-4.687-12.284 0-16.97 4.687-4.687 12.284-4.687 16.97 0M13 21.333h6M11.5 16.667h9M10 12h12"
        }));
      }
    case 'alert-indicator':
      {
        return /*#__PURE__*/_react.default.createElement(_components.BaseSvg, _extends({
          size: size,
          viewBoxSize: 8,
          className: (0, _classnames.default)('fill-current', className)
        }, props), /*#__PURE__*/_react.default.createElement("circle", {
          cx: "4",
          cy: "4",
          r: "4"
        }));
      }
    case 'close-16':
      {
        return /*#__PURE__*/_react.default.createElement(_components.BaseSvg, _extends({
          size: size,
          viewBoxSize: 16,
          className: (0, _classnames.default)('fill-current', className)
        }, props), /*#__PURE__*/_react.default.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M1.282 2.283a.753.753 0 010-1.063.747.747 0 011.06 0l5.66 5.68 5.652-5.68a.746.746 0 011.058 0 .755.755 0 010 1.064L9.061 7.963l5.724 5.744a.753.753 0 010 1.062.747.747 0 01-1.059 0L8.002 9.026l-5.725 5.753a.746.746 0 01-1.058 0 .754.754 0 010-1.064l5.725-5.752-5.662-5.68z"
        }));
      }
    case 'close-24':
      {
        return /*#__PURE__*/_react.default.createElement(_components.BaseSvg, _extends({
          size: size,
          viewBoxSize: 24,
          className: (0, _classnames.default)('fill-current', className)
        }, props), /*#__PURE__*/_react.default.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M20.702 4.707a1 1 0 00-1.414-1.414L12 10.583l-7.286-7.29a1 1 0 10-1.414 1.414l7.287 7.29-7.295 7.297a1 1 0 001.414 1.415l7.295-7.298 7.294 7.298a1 1 0 101.414-1.415l-7.295-7.297 7.287-7.29z"
        }));
      }
    case 'search-16':
      {
        return /*#__PURE__*/_react.default.createElement(_components.BaseSvg, _extends({
          size: size,
          viewBoxSize: 16,
          className: (0, _classnames.default)('fill-current', className)
        }, props), /*#__PURE__*/_react.default.createElement("path", {
          d: "M6.482 1c3.006 0 5.482 2.476 5.482 5.482a5.31 5.31 0 01-1.105 3.271l3.89 3.89c.752.752-.354 1.858-1.105 1.106l-3.89-3.89a5.31 5.31 0 01-3.272 1.105C3.476 11.964 1 9.488 1 6.482 1 3.476 3.476 1 6.482 1zm0 1.592a3.868 3.868 0 00-3.89 3.89 3.868 3.868 0 003.89 3.89 3.868 3.868 0 003.89-3.89 3.868 3.868 0 00-3.89-3.89z"
        }));
      }
    case 'search-24':
      {
        return /*#__PURE__*/_react.default.createElement(_components.BaseSvg, _extends({
          size: size,
          viewBoxSize: 24,
          className: (0, _classnames.default)('fill-current', className)
        }, props), /*#__PURE__*/_react.default.createElement("path", {
          d: "M10.048 3c3.865 0 7.048 3.183 7.048 7.048a6.827 6.827 0 01-1.42 4.206l5.001 5.002c.967.967-.454 2.388-1.42 1.421l-5.003-5.002a6.827 6.827 0 01-4.206 1.421C6.183 17.096 3 13.913 3 10.048S6.183 3 10.048 3zm0 2.046a4.973 4.973 0 00-5.002 5.002 4.973 4.973 0 005.002 5.002 4.973 4.973 0 005.002-5.002 4.973 4.973 0 00-5.002-5.002z"
        }));
      }
    case 'close-bubble':
      {
        return /*#__PURE__*/_react.default.createElement(_components.BaseSvg, _extends({
          size: size,
          viewBoxSize: 16,
          className: (0, _classnames.default)('fill-current', className)
        }, props), /*#__PURE__*/_react.default.createElement("g", {
          clipPath: "url(#clip0)",
          fillRule: "evenodd",
          clipRule: "evenodd"
        }, /*#__PURE__*/_react.default.createElement("path", {
          d: "M8 0a8 8 0 100 16A8 8 0 008 0zm0 1c3.859 0 7 3.14 7 7s-3.141 7-7 7c-3.86 0-7-3.14-7-7s3.14-7 7-7z"
        }), /*#__PURE__*/_react.default.createElement("path", {
          d: "M11.602 10.82c.22.22.22.56 0 .78a.524.524 0 01-.39.17c-.15 0-.29-.06-.39-.17l-2.82-2.82-2.83 2.82c-.1.11-.24.17-.39.17-.15 0-.29-.06-.39-.17a.548.548 0 01-.16-.39c0-.15.06-.29.16-.39L7.213 8l-2.82-2.82a.574.574 0 010-.79.552.552 0 01.78 0l2.83 2.82 2.82-2.82a.552.552 0 01.78 0c.22.22.22.57 0 .79L8.782 8l2.82 2.82z"
        })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
          id: "clip0"
        }, /*#__PURE__*/_react.default.createElement("path", {
          fill: "#fff",
          d: "M0 0h16v16H0z"
        }))));
      }
    case 'close-bubble-filled':
      {
        return (
          /*#__PURE__*/
          // TODO: If different fill colors are needed for this icon, figure out how to specify them
          _react.default.createElement(_components.BaseSvg, _extends({
            size: size,
            viewBoxSize: 16,
            className: (0, _classnames.default)('fill-current', className)
          }, props), /*#__PURE__*/_react.default.createElement("rect", {
            width: "16",
            height: "16",
            rx: "8",
            fill: "#E7E8E8"
          }), /*#__PURE__*/_react.default.createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M5.008 11.825a.576.576 0 01-.828 0A.557.557 0 014 11.41c0-.158.064-.308.18-.413l2.992-2.995L4.18 4.997A.552.552 0 014 4.584c0-.16.064-.308.18-.414A.581.581 0 014.594 4c.16 0 .308.063.414.17L8 7.163l2.992-2.993a.607.607 0 01.838 0 .585.585 0 010 .827L8.838 8.002l2.992 2.995a.589.589 0 11-.838.828L8 8.831l-2.992 2.994z",
            fill: "#3E4145"
          }))
        );
      }
    case 'close-bubble-no-bubble':
      {
        return /*#__PURE__*/_react.default.createElement(_components.BaseSvg, _extends({
          size: size,
          viewBoxSize: 16,
          className: (0, _classnames.default)('fill-current', className)
        }, props), /*#__PURE__*/_react.default.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M5.008 11.825a.576.576 0 01-.828 0A.557.557 0 014 11.41c0-.158.064-.308.18-.413l2.992-2.995L4.18 4.997A.552.552 0 014 4.584c0-.16.064-.308.18-.414A.581.581 0 014.594 4c.16 0 .308.063.414.17L8 7.163l2.992-2.993a.607.607 0 01.838 0 .585.585 0 010 .827L8.838 8.002l2.992 2.995a.589.589 0 11-.838.828L8 8.831l-2.992 2.994z"
        }));
      }
    case 'filter-16':
      {
        return /*#__PURE__*/_react.default.createElement(_components.BaseSvg, _extends({
          size: size,
          viewBoxSize: 16,
          className: (0, _classnames.default)('fill-current', className)
        }, props), /*#__PURE__*/_react.default.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M3.222 1.311v7.478l.664.005V1.311c0-.174-.146-.311-.332-.311-.186 0-.332.137-.332.311zm.312 10.36a.904.904 0 01-.896-.905.9.9 0 111.8 0 .91.91 0 01-.904.905zm0-2.449a1.54 1.54 0 000 3.08c.85.001 1.541-.691 1.541-1.536 0-.852-.69-1.544-1.54-1.544zm-.312 3.447l-.007 1.97c0 .195.147.361.333.361.185 0 .338-.159.338-.36l.007-1.978-.67.007zM12.48 1c-.187 0-.333.137-.333.311v7.48l.664.006V1.311c0-.174-.146-.311-.332-.311zm-.015 10.685a.904.904 0 010-1.81.91.91 0 01.904.905.914.914 0 01-.904.905zm0-2.449c-.85 0-1.54.692-1.54 1.544 0 .845.69 1.537 1.54 1.537a1.54 1.54 0 000-3.08zm-.311 3.434l-.007 1.97c0 .194.146.36.332.36.18 0 .332-.159.332-.36l.007-1.977-.664.007zM8.023 1c-.192 0-.338.13-.338.298v2.808h.67V1.298c0-.167-.152-.298-.332-.298zm-.02 5.983a.905.905 0 010-1.81.906.906 0 010 1.81zm0-2.442c-.85 0-1.54.685-1.54 1.537 0 .845.69 1.537 1.54 1.537a1.536 1.536 0 000-3.074zm-.312 3.515l-.006 6.604c0 .183.146.34.332.34.186 0 .332-.15.332-.34l.006-6.61-.664.006z"
        }));
      }
    case 'filter-24':
      {
        return /*#__PURE__*/_react.default.createElement(_components.BaseSvg, _extends({
          size: size,
          viewBoxSize: 24,
          className: (0, _classnames.default)('fill-current', className)
        }, props), /*#__PURE__*/_react.default.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M6.572 3.4v9.614l.855.007V3.4c0-.224-.188-.4-.427-.4-.24 0-.428.176-.428.4zm.402 13.32c-.64 0-1.154-.53-1.154-1.164a1.157 1.157 0 112.316 0 1.17 1.17 0 01-1.162 1.164zm0-3.149a1.982 1.982 0 000 3.961c1.094 0 1.983-.89 1.983-1.976a1.985 1.985 0 00-1.983-1.985zm-.402 4.432l-.008 2.533c0 .25.188.464.427.464.24 0 .436-.204.436-.464l.008-2.542-.863.01zM17.043 3c-.24 0-.427.176-.427.4v9.618l.854.007V3.4c0-.224-.188-.4-.427-.4zm-.018 13.738a1.163 1.163 0 010-2.327 1.17 1.17 0 011.163 1.164c0 .633-.53 1.163-1.163 1.163zm0-3.148c-1.093 0-1.981.89-1.981 1.985 0 1.086.888 1.976 1.981 1.976a1.982 1.982 0 000-3.961zm-.4 4.414l-.01 2.532c0 .25.189.464.428.464.23 0 .427-.204.427-.464l.009-2.541-.855.01zM12.03 3c-.248 0-.436.168-.436.383v3.61h.863v-3.61c0-.215-.196-.383-.427-.383zm-.026 7.692a1.164 1.164 0 010-2.327 1.165 1.165 0 010 2.327zm0-3.14a1.978 1.978 0 00-1.982 1.977c0 1.086.889 1.976 1.982 1.976a1.976 1.976 0 000-3.952zm-.401 4.52l-.009 8.49c0 .237.188.438.427.438.24 0 .428-.193.428-.438l.008-8.498-.854.008z"
        }));
      }
    case 'edit-pencil':
      {
        return /*#__PURE__*/_react.default.createElement(_components.BaseSvg, _extends({
          size: size,
          viewBoxSize: 24,
          className: (0, _classnames.default)('fill-current', className)
        }, props), /*#__PURE__*/_react.default.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M19.513 8.284a2.035 2.035 0 00-.14-2.792l-2.115-1.984a1.844 1.844 0 00-2.68.146l-.634.735-.889 1.028-6.092 7.051-.889 1.028-.38.441L4.02 20.25a.617.617 0 00.018.375.562.562 0 00.738.335l5.85-2.393 8.886-10.283zm-5.47-1.941l-6.093 7.05 2.96 2.779 6.093-7.051-2.96-2.778zm3.848 1.75l.635-.735a.61.61 0 00-.042-.838l-2.115-1.984a.553.553 0 00-.803.044l-.635.735 2.96 2.777zM6.89 14.62l.171-.198 2.96 2.778-.17.198-4.146 1.696L6.89 14.62z"
        }));
      }
    case 'edit-pencil-filled':
      {
        return /*#__PURE__*/_react.default.createElement(_components.BaseSvg, _extends({
          size: size,
          viewBoxSize: 24,
          className: (0, _classnames.default)('fill-current', className)
        }, props), /*#__PURE__*/_react.default.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M17.97 10.075l-6.066 7.02-.989-.93-2.946-2.8-.979-.93 6.056-7.01.989.93 2.956 2.79.979.93z"
        }), /*#__PURE__*/_react.default.createElement("mask", {
          id: "a",
          maskUnits: "userSpaceOnUse",
          x: "13",
          y: "3",
          width: "7",
          height: "7"
        }, /*#__PURE__*/_react.default.createElement("path", {
          d: "M13.968 3H20v6.015h-6.032V3z",
          fill: "#fff"
        })), /*#__PURE__*/_react.default.createElement("g", {
          mask: "url(#a)"
        }, /*#__PURE__*/_react.default.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M19.515 8.285l-.633.73-.98-.93-2.956-2.79-.978-.93.613-.71a1.844 1.844 0 012.678-.15l2.112 1.99c.778.73.844 1.98.144 2.79z"
        })), /*#__PURE__*/_react.default.createElement("mask", {
          id: "b",
          maskUnits: "userSpaceOnUse",
          x: "4",
          y: "13",
          width: "7",
          height: "9"
        }, /*#__PURE__*/_react.default.createElement("path", {
          d: "M4 13.505h6.992V21H4v-7.496z",
          fill: "#fff"
        })), /*#__PURE__*/_react.default.createElement("g", {
          mask: "url(#b)"
        }, /*#__PURE__*/_react.default.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M10.992 18.145l-.365.42-5.854 2.4a.58.58 0 01-.739-.34.61.61 0 01-.01-.37l1.67-6.32.375-.43.988.92 2.947 2.79.988.93z"
        })));
      }
    case 'home':
      {
        return /*#__PURE__*/_react.default.createElement(_components.BaseSvg, _extends({
          size: size,
          viewBoxSize: 24,
          className: (0, _classnames.default)('fill-current', className)
        }, props), /*#__PURE__*/_react.default.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M13.563 12.487h-3.176c-1.121 0-2.035.993-2.035 2.225v7.967c0 .149-.109.267-.248.267H3.221c-.14 0-.248-.118-.248-.267V9.219c0-.08.04-.16.109-.23l8.784-7.886c.05-.05.11-.05.139-.05.02 0 .08 0 .12.05L20.937 9c.06.06.09.13.09.219v13.46c0 .159-.1.267-.239.267h-4.943c-.129 0-.237-.118-.237-.267v-7.967c0-1.232-.924-2.225-2.046-2.225zm7.99-4.282L12.76.297A1.132 1.132 0 0012.005 0c-.278 0-.556.11-.764.297L2.457 8.195A1.37 1.37 0 002 9.22v13.46C2 23.404 2.546 24 3.22 24h4.884c.675 0 1.221-.596 1.221-1.321v-7.967c0-.656.476-1.182 1.062-1.182h3.176c.586 0 1.062.526 1.062 1.182v7.967c0 .725.546 1.321 1.221 1.321h4.943c.665 0 1.211-.596 1.211-1.321V9.219c0-.398-.169-.775-.447-1.014z"
        }));
      }
    case 'home-filled':
      {
        return /*#__PURE__*/_react.default.createElement(_components.BaseSvg, _extends({
          size: size,
          viewBoxSize: 24,
          className: (0, _classnames.default)('fill-current', className)
        }, props), /*#__PURE__*/_react.default.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M22 9.219v13.46c0 .725-.546 1.321-1.211 1.321h-4.942c-.675 0-1.221-.596-1.221-1.321v-7.967c0-.656-.477-1.182-1.063-1.182h-3.176c-.585 0-1.062.526-1.062 1.182v7.967c0 .725-.546 1.321-1.221 1.321H3.221C2.546 24 2 23.404 2 22.679V9.219c0-.388.169-.775.457-1.023L11.241.298c.208-.188.487-.298.764-.298.278 0 .546.11.755.298l8.794 7.907c.278.239.446.617.446 1.014z"
        }));
      }
    case 'my-care':
      {
        return /*#__PURE__*/_react.default.createElement(_components.BaseSvg, _extends({
          size: size,
          viewBoxSize: 24,
          className: (0, _classnames.default)('fill-current', className)
        }, props), /*#__PURE__*/_react.default.createElement("mask", {
          id: "a",
          maskUnits: "userSpaceOnUse",
          x: "0",
          y: "0",
          width: "24",
          height: "24"
        }, /*#__PURE__*/_react.default.createElement("path", {
          d: "M0 0h24v24H0V0z",
          fill: "#fff"
        })), /*#__PURE__*/_react.default.createElement("g", {
          mask: "url(#a)"
        }, /*#__PURE__*/_react.default.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M20.046 23.075H3.954a3.036 3.036 0 01-3.03-3.03v-16.1A3.027 3.027 0 013.954.924h16.092a3.02 3.02 0 013.02 3.021v16.1a3.028 3.028 0 01-3.02 3.03zm0-23.075H3.954A3.956 3.956 0 000 3.945v16.1A3.965 3.965 0 003.954 24h16.092A3.965 3.965 0 0024 20.045v-16.1A3.956 3.956 0 0020.046 0z"
        })), /*#__PURE__*/_react.default.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M5.702 13.773v-3.667h4.47V5.634h3.656v4.472h4.47v3.667h-4.47v4.473h-3.656v-4.473h-4.47zm12.854-4.59h-3.794V5.136a.447.447 0 00-.438-.427H9.675a.433.433 0 00-.437.427v4.045H5.444a.674.674 0 00-.676.666v4.174a.67.67 0 00.676.676h3.794v3.796a.67.67 0 00.676.675h4.172a.683.683 0 00.676-.675v-3.796h3.794a.683.683 0 00.675-.676V9.848a.674.674 0 00-.675-.666z"
        }));
      }
    case 'my-care-filled':
      {
        return /*#__PURE__*/_react.default.createElement(_components.BaseSvg, _extends({
          size: size,
          viewBoxSize: 24,
          className: (0, _classnames.default)('fill-current', className)
        }, props), /*#__PURE__*/_react.default.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M18.3 10.109v3.67h-4.47v4.471h-3.649v-4.471H5.71v-3.67h4.471v-4.47h3.649v4.47h4.47zM20.05 0H3.96A3.96 3.96 0 000 3.949v16.1C0 22.229 1.78 24 3.96 24h16.09A3.952 3.952 0 0024 20.049v-16.1A3.95 3.95 0 0020.05 0z"
        }));
      }
    case 'groups':
      {
        return /*#__PURE__*/_react.default.createElement(_components.BaseSvg, _extends({
          size: size,
          viewBoxSize: 24,
          className: (0, _classnames.default)('fill-current', className)
        }, props), /*#__PURE__*/_react.default.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M1.003 21.862c.568.306 2.416 1.137 5.703 1.137 3.285 0 5.133-.83 5.703-1.138.022-.326.044-.95-.022-1.677-.25-2.773-1.048-4.15-2.422-5.511-.853.746-1.97 1.136-3.26 1.136-1.29 0-2.405-.39-3.26-1.136-1.373 1.362-2.171 2.738-2.421 5.51a11.234 11.234 0 00-.021 1.679zM6.706 24C2.36 24 .345 22.635.26 22.577a.502.502 0 01-.211-.354 11.36 11.36 0 01-.002-2.13c.298-3.297 1.35-4.872 3.069-6.478a.484.484 0 01.69.028c.707.774 1.682 1.166 2.899 1.166 1.216 0 2.192-.392 2.899-1.166a.481.481 0 01.689-.028c1.718 1.606 2.772 3.18 3.069 6.478a11.256 11.256 0 01-.002 2.13.496.496 0 01-.211.354c-.084.058-2.1 1.423-6.444 1.423zM6.704 4.175c2.43 0 4.4 2.01 4.4 4.492 0 2.479-1.97 4.49-4.4 4.49-2.43 0-4.4-2.011-4.4-4.49 0-2.482 1.97-4.492 4.4-4.492zm0 1.02c-1.87 0-3.4 1.562-3.4 3.472 0 1.908 1.53 3.469 3.4 3.469 1.88 0 3.4-1.56 3.4-3.47 0-1.91-1.52-3.47-3.4-3.47zM16.087 18.833c.53.064 1.07.108 1.572.084 3.36-.144 4.86-.85 5.316-1.118.022-.32.05-.948-.023-1.68-.283-2.982-.995-4.289-2.272-5.518-.902.72-2.234 1.14-3.668 1.14a5.407 5.407 0 01-3.118-.98 5.114 5.114 0 01-.645 1.744c1.556 1.68 2.613 3.772 2.787 5.544.034.349.047.584.051.784zm1.302 1.111c-.62 0-1.259-.072-1.864-.153a.507.507 0 01-.436-.506v-.117c.001-.271.002-.514-.047-1.016-.163-1.655-1.229-3.656-2.784-5.222a.518.518 0 01-.055-.66c.616-.878.707-1.575.822-2.454.026-.192.163-.403.344-.465.181-.061.388-.06.521.079.777.808 1.944 1.29 3.122 1.29 1.378 0 2.617-.434 3.314-1.163a.496.496 0 01.688-.026c1.642 1.472 2.596 2.942 2.934 6.49a10.66 10.66 0 01-.002 2.134.513.513 0 01-.172.325c-.15.129-1.588 1.266-6.074 1.458a7.793 7.793 0 01-.31.006zM17.084 0c2.42 0 4.4 2.01 4.4 4.492 0 2.47-1.98 4.49-4.4 4.49-2.43 0-4.4-2.02-4.4-4.49 0-2.481 1.97-4.492 4.4-4.492zm0 1.02c-1.88 0-3.4 1.553-3.4 3.472 0 1.909 1.52 3.47 3.4 3.47 1.87 0 3.4-1.561 3.4-3.47 0-1.919-1.53-3.471-3.4-3.471z"
        }));
      }
    case 'groups-filled':
      {
        return /*#__PURE__*/_react.default.createElement(_components.BaseSvg, _extends({
          size: size,
          viewBoxSize: 24,
          className: (0, _classnames.default)('fill-current', className)
        }, props), /*#__PURE__*/_react.default.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M13.364 22.207a.534.534 0 01-.21.359c-.09.061-2.1 1.434-6.45 1.434-4.34 0-6.36-1.373-6.44-1.434a.486.486 0 01-.21-.359c-.01-.03-.11-.952-.01-2.13.3-3.31 1.35-4.897 3.07-6.505a.48.48 0 01.69.03c.71.78 1.68 1.168 2.9 1.168s2.19-.389 2.9-1.167a.481.481 0 01.69-.031c1.72 1.608 2.77 3.195 3.07 6.505.11 1.178 0 2.1 0 2.13zM11.104 8.604c0 2.49-1.97 4.507-4.4 4.507-2.43 0-4.4-2.017-4.4-4.507 0-2.49 1.97-4.507 4.4-4.507 2.43 0 4.4 2.017 4.4 4.507zM23.944 18.223a.482.482 0 01-.17.328c-.15.123-1.59 1.271-6.07 1.465h-.31c-.62 0-1.26-.071-1.87-.153a.498.498 0 01-.43-.503v-.123c0-.266 0-.512-.05-1.014-.16-1.67-1.23-3.677-2.79-5.244a.537.537 0 01-.05-.666c.62-.882.71-1.578.82-2.459.03-.194.16-.409.35-.471.18-.06.38-.051.52.082.77.809 1.94 1.302 3.12 1.302 1.38 0 2.62-.442 3.31-1.17a.49.49 0 01.69-.029c1.64 1.474 2.6 2.95 2.93 6.514.12 1.18.01 2.1 0 2.141zM21.484 4.507c0 2.48-1.98 4.507-4.4 4.507-2.43 0-4.4-2.028-4.4-4.507 0-2.489 1.97-4.507 4.4-4.507 2.42 0 4.4 2.018 4.4 4.507z"
        }));
      }
    case 'resources':
      {
        return /*#__PURE__*/_react.default.createElement(_components.BaseSvg, _extends({
          size: size,
          viewBoxSize: 24,
          className: (0, _classnames.default)('fill-current', className)
        }, props), /*#__PURE__*/_react.default.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M21.087 22.032c0 .576-.467 1.054-1.052 1.054H4.968a2.06 2.06 0 01-2.055-2.058c0-1.133.924-2.047 2.055-2.047H18.03c.347 0 .685-.099.983-.278l.069-.04v1.769c0 .089-.059.139-.149.139H5.018v.915h13.915c.586 0 1.062-.477 1.062-1.054V3.916h.04c.585 0 1.052.476 1.052 1.053v17.063zM3.965.904H18.03a1.06 1.06 0 011.052 1.054v15.055a1.06 1.06 0 01-1.052 1.054H4.968c-.725 0-1.42.269-1.975.755l-.08.08V1.958A1.06 1.06 0 013.965.904zm16.07 2.107h-.04V1.958A1.963 1.963 0 0018.03 0H3.965A1.963 1.963 0 002 1.958v19.07A2.971 2.971 0 004.968 24h15.067A1.971 1.971 0 0022 22.032V4.969a1.963 1.963 0 00-1.965-1.958z"
        }), /*#__PURE__*/_react.default.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M15.515 9.475c0 .26-.21.48-.48.48h-8.09a.48.48 0 110-.96h8.09c.27 0 .48.21.48.48zM15.515 6.445c0 .26-.21.47-.48.47h-8.09a.474.474 0 110-.95h8.09c.27 0 .48.21.48.48z"
        }));
      }
    case 'resources-filled':
      {
        return /*#__PURE__*/_react.default.createElement(_components.BaseSvg, _extends({
          size: size,
          viewBoxSize: 24,
          className: (0, _classnames.default)('fill-current', className)
        }, props), /*#__PURE__*/_react.default.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M21 5.027v16.931c0 .567-.466 1.042-1.04 1.042H5.032A2.037 2.037 0 013 20.958c0-1.121.911-2.024 2.032-2.024h12.937c.346 0 .684-.1.981-.279l.069-.04v1.842c0 .089-.06.138-.148.138H5.081v.724h13.79c.575 0 1.05-.476 1.05-1.042V3.985h.039c.574 0 1.04.477 1.04 1.042z"
        }), /*#__PURE__*/_react.default.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M15.007 6.961H6.992a.467.467 0 01-.474-.466.47.47 0 01.474-.476h8.015a.47.47 0 01.475.476.467.467 0 01-.475.466zm0 3.016H6.992a.475.475 0 01-.474-.475.47.47 0 01.474-.478h8.015a.47.47 0 01.475.478.475.475 0 01-.475.475zM17.969 1H4.04C3.467 1 3 1.476 3 2.041v16.813l.08-.08a2.935 2.935 0 011.952-.753h12.937c.574 0 1.05-.466 1.05-1.04V2.04c0-.565-.476-1.041-1.05-1.041z"
        }));
      }
    case 'alert':
      {
        return /*#__PURE__*/_react.default.createElement(_components.BaseSvg, _extends({
          size: size,
          viewBoxSize: 24,
          className: (0, _classnames.default)('fill-current', className)
        }, props), /*#__PURE__*/_react.default.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12 3.364c-4.762 0-8.636 3.874-8.636 8.636 0 4.762 3.874 8.636 8.636 8.636 4.762 0 8.636-3.874 8.636-8.636 0-4.762-3.874-8.636-8.636-8.636zM12 22C6.486 22 2 17.514 2 12S6.486 2 12 2s10 4.486 10 10-4.486 10-10 10z"
        }), /*#__PURE__*/_react.default.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M11.034 16.732h1.934v-1.884h-1.934v1.884zM11.008 7.269l.178 6.11h1.629l.179-6.11h-1.986z"
        }));
      }
    case 'alert-filled':
      {
        return /*#__PURE__*/_react.default.createElement(_components.BaseSvg, _extends({
          size: size,
          viewBoxSize: 24,
          className: (0, _classnames.default)('fill-current', className)
        }, props), /*#__PURE__*/_react.default.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12.81 13.373h-1.628l-.172-6.11h1.98l-.18 6.11zm-1.783 3.354h1.937v-1.882h-1.937v1.882zM12 2C6.482 2 2 6.482 2 12c0 5.51 4.482 10 10 10 5.51 0 10-4.49 10-10 0-5.518-4.49-10-10-10z"
        }));
      }
    case 'info':
      {
        return /*#__PURE__*/_react.default.createElement(_components.BaseSvg, _extends({
          size: size,
          viewBoxSize: 24,
          className: (0, _classnames.default)('fill-current', className)
        }, props), /*#__PURE__*/_react.default.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12 3.364c-4.762 0-8.636 3.874-8.636 8.636 0 4.762 3.874 8.636 8.636 8.636 4.762 0 8.636-3.874 8.636-8.636 0-4.762-3.874-8.636-8.636-8.636zM12 22C6.486 22 2 17.514 2 12S6.486 2 12 2s10 4.486 10 10-4.486 10-10 10z"
        }), /*#__PURE__*/_react.default.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M9.567 16.94c0-.226.34-1.141 1.022-2.746.681-1.605 1.022-2.456 1.022-2.553 0-.147-.052-.22-.153-.22-.111 0-.256.054-.436.163-.18.11-.335.218-.463.33l-.186.16-.22-.42c.78-.963 1.562-1.445 2.345-1.445.27 0 .494.09.671.27.178.179.267.433.267.762 0 .235-.123.679-.367 1.329a39.97 39.97 0 01-.845 2.06c-.32.723-.502 1.15-.546 1.279l.04.106c.209-.07.46-.218.752-.443.294-.223.52-.45.678-.676l.208.48c-.208.417-.648.85-1.315 1.3-.669.453-1.24.677-1.715.677-.245 0-.432-.04-.562-.122-.132-.083-.197-.18-.197-.29zM12.353 8.721a1.183 1.183 0 01-.35-.86c0-.334.12-.62.358-.858a1.17 1.17 0 01.858-.357c.335 0 .622.12.859.357.237.238.356.524.356.859 0 .335-.119.622-.356.859a1.167 1.167 0 01-.856.356 1.17 1.17 0 01-.869-.356z"
        }));
      }
    case 'info-filled':
      {
        return /*#__PURE__*/_react.default.createElement(_components.BaseSvg, _extends({
          size: size,
          viewBoxSize: 24,
          className: (0, _classnames.default)('fill-current', className)
        }, props), /*#__PURE__*/_react.default.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M14.073 8.718a1.161 1.161 0 01-.855.355c-.345 0-.637-.118-.864-.355A1.183 1.183 0 0112 7.855c0-.328.118-.619.354-.855a1.18 1.18 0 01.864-.355c.337 0 .617.119.855.355.236.236.354.527.354.855 0 .336-.118.627-.354.863zm-2.356 7.291c.21-.064.455-.218.746-.436.3-.228.519-.455.682-.682l.21.482c-.21.418-.646.854-1.319 1.3-.664.454-1.237.682-1.709.682-.246 0-.437-.046-.563-.128-.138-.082-.2-.181-.2-.29 0-.228.345-1.137 1.027-2.746.672-1.61 1.018-2.455 1.018-2.555 0-.145-.055-.218-.155-.218-.109 0-.254.055-.436.164-.183.109-.336.218-.463.327l-.182.164-.22-.418c.774-.964 1.555-1.446 2.338-1.446.273 0 .5.091.673.264.18.181.272.436.272.763 0 .237-.128.682-.372 1.328a42.5 42.5 0 01-.846 2.063c-.319.727-.5 1.146-.546 1.282l.045.1zM12 2C6.48 2 2 6.482 2 12c0 5.51 4.48 10 10 10 5.508 0 10-4.49 10-10 0-5.518-4.492-10-10-10z"
        }));
      }
    case 'schedule':
      {
        return /*#__PURE__*/_react.default.createElement(_components.BaseSvg, _extends({
          size: size,
          viewBoxSize: 24,
          fill: "none",
          className: (0, _classnames.default)('stroke-current', className)
        }, props), /*#__PURE__*/_react.default.createElement("path", {
          d: "M14.5984 2V5.6",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }), /*#__PURE__*/_react.default.createElement("path", {
          d: "M7.39922 2V5.6",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }), /*#__PURE__*/_react.default.createElement("path", {
          d: "M2.89844 8.29998H19.0984",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }), /*#__PURE__*/_react.default.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M17.2984 3.80005H4.69844C3.70394 3.80005 2.89844 4.60555 2.89844 5.60005V17.3C2.89844 18.2945 3.70394 19.1 4.69844 19.1H17.2984C18.2929 19.1 19.0984 18.2945 19.0984 17.3V5.60005C19.0984 4.60555 18.2929 3.80005 17.2984 3.80005Z",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }), /*#__PURE__*/_react.default.createElement("path", {
          d: "M11.0116 11.6562C10.8874 11.6562 10.7866 11.757 10.7875 11.8812C10.7875 12.0054 10.8883 12.1062 11.0125 12.1062C11.1367 12.1062 11.2375 12.0054 11.2375 11.8812C11.2375 11.757 11.1367 11.6562 11.0116 11.6562",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }), /*#__PURE__*/_react.default.createElement("path", {
          d: "M15.5116 11.6562C15.3874 11.6562 15.2866 11.757 15.2875 11.8812C15.2875 12.0054 15.3883 12.1062 15.5125 12.1062C15.6367 12.1062 15.7375 12.0054 15.7375 11.8812C15.7375 11.757 15.6367 11.6562 15.5116 11.6562",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }), /*#__PURE__*/_react.default.createElement("path", {
          d: "M6.5116 15.2561C6.3874 15.2561 6.2866 15.3569 6.2875 15.4811C6.2875 15.6053 6.3883 15.7061 6.5125 15.7061C6.6367 15.7061 6.7375 15.6053 6.7375 15.4811C6.7375 15.3569 6.6367 15.2561 6.5116 15.2561",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }), /*#__PURE__*/_react.default.createElement("path", {
          d: "M11.0116 15.2561C10.8874 15.2561 10.7866 15.3569 10.7875 15.4811C10.7875 15.6053 10.8883 15.7061 11.0125 15.7061C11.1367 15.7061 11.2375 15.6053 11.2375 15.4811C11.2375 15.3569 11.1367 15.2561 11.0116 15.2561",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }));
      }
    case 'reschedule':
      {
        return /*#__PURE__*/_react.default.createElement(_components.BaseSvg, _extends({
          size: size,
          viewBoxSize: 24,
          fill: "none",
          className: (0, _classnames.default)('stroke-current', className)
        }, props), /*#__PURE__*/_react.default.createElement("path", {
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "1.5",
          d: "M15 3v2M7 3v2M3 9h16M19 10V7a3 3 0 0 0-3-3H6a3 3 0 0 0-3 3v9a3 3 0 0 0 3 3h4M17.393 15.983v1.758l1.382.843"
        }), /*#__PURE__*/_react.default.createElement("path", {
          strokeWidth: "1.5",
          d: "M17.5 22a4.5 4.5 0 0 1-4.5-4.5c0-2.434 2.07-4.503 4.504-4.5a4.5 4.5 0 0 1-.004 9"
        }));
      }
    case 'show-password':
      {
        return /*#__PURE__*/_react.default.createElement(_components.BaseSvg, _extends({
          size: size,
          viewBoxSize: 24,
          className: (0, _classnames.default)('fill-current', className)
        }, props), /*#__PURE__*/_react.default.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12 7c-3.636 0-6.742 2.073-8 5 1.258 2.927 4.364 5 8 5s6.742-2.073 8-5c-1.258-2.927-4.364-5-8-5zm0 8.333c-2.007 0-3.636-1.493-3.636-3.333S9.993 8.667 12 8.667 15.636 10.16 15.636 12 14.007 15.333 12 15.333zM9.818 12c0-1.107.975-2 2.182-2 1.207 0 2.182.893 2.182 2s-.975 2-2.182 2c-1.207 0-2.182-.893-2.182-2z"
        }));
      }
    case 'hide-password':
      {
        return /*#__PURE__*/_react.default.createElement(_components.BaseSvg, _extends({
          size: size,
          viewBoxSize: 24,
          className: (0, _classnames.default)('fill-current', className)
        }, props), /*#__PURE__*/_react.default.createElement("g", {
          transform: "translate(3, 3)"
        }, /*#__PURE__*/_react.default.createElement("path", {
          d: "M13.88,5.24 L11.87,7.25 C12.05,7.64 12.14,8.06 12.14,8.5 C12.14,10.34 10.51,11.83 8.5,11.83 C8.13,11.83 7.78,11.78 7.44,11.68 L5.97,13.15 C6.77,13.38 7.62,13.5 8.5,13.5 C12.14,13.5 15.24,11.42 16.5,8.5 C15.95,7.22 15.04,6.09 13.88,5.24 M8.5,3.5 C4.87,3.5 1.76,5.57 0.5,8.5 C1.05,9.78 1.96,10.9 3.11,11.76 L5.13,9.74 C4.96,9.36 4.87,8.94 4.87,8.5 C4.87,6.66 6.5,5.16 8.5,5.16 C8.87,5.16 9.22,5.21 9.56,5.31 L11.02,3.85 C10.22,3.62 9.38,3.5 8.5,3.5",
          id: "Fill-1"
        }), /*#__PURE__*/_react.default.createElement("path", {
          d: "M16.86,0.85 L0.86,16.85 C0.76,16.95 0.63,17 0.5,17 C0.37,17 0.25,16.95 0.15,16.85 C-0.05,16.65 -0.05,16.34 0.15,16.14 L16.15,0.14 C16.25,0.04 16.37,0 16.5,0 C16.63,0 16.76,0.04 16.86,0.14 C17.05,0.34 17.05,0.65 16.86,0.85",
          id: "Fill-3",
          mask: "url(#mask-2)"
        })));
      }
    case 'message-letter':
      {
        return /*#__PURE__*/_react.default.createElement(_components.BaseSvg, _extends({
          size: size,
          viewBoxSize: 24,
          fillOpacity: "0",
          className: (0, _classnames.default)('stroke-current', className)
        }, props), /*#__PURE__*/_react.default.createElement("path", {
          d: "M20.5 9.297V17.5h-17V9.297l7.857 5.36h0a1.142 1.142 0 001.286 0h0l7.857-5.36zM12 12.326L3.5 6.533V6.5h17v.033L12 12.326z",
          strokeLinecap: "round"
        }));
      }
    case 'enter':
      {
        return /*#__PURE__*/_react.default.createElement(_components.BaseSvg, _extends({
          size: size,
          viewBoxSize: 24,
          className: (0, _classnames.default)('fill-current', className)
        }, props), /*#__PURE__*/_react.default.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M13.155 22H3.628C2.73 22 2 21.243 2 20.312V3.688C2 2.758 2.73 2 3.628 2h9.527c.345 0 .626.29.626.65 0 .358-.28.649-.626.649H3.628a.384.384 0 00-.376.39v16.623c0 .215.17.39.376.39h9.527c.345 0 .626.29.626.649 0 .358-.28.649-.626.649z"
        }), /*#__PURE__*/_react.default.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M14.853 16.915c.22.258.598.281.845.052a.646.646 0 00.05-.882l-2.837-3.335h8.491c.33 0 .598-.28.598-.625a.612.612 0 00-.598-.625h-8.705l3.051-3.585a.646.646 0 00-.05-.882.582.582 0 00-.845.052L10.67 12l4.182 4.915z"
        }));
      }
    case 'exit':
      {
        return /*#__PURE__*/_react.default.createElement(_components.BaseSvg, _extends({
          size: size,
          viewBoxSize: 24,
          className: (0, _classnames.default)('fill-current', className)
        }, props), /*#__PURE__*/_react.default.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M13.155 22H3.628C2.73 22 2 21.243 2 20.312V3.688C2 2.758 2.73 2 3.628 2h9.527c.345 0 .626.29.626.65 0 .358-.28.649-.626.649H3.628a.384.384 0 00-.376.39v16.623c0 .215.17.39.376.39h9.527c.345 0 .626.29.626.649 0 .358-.28.649-.626.649z"
        }), /*#__PURE__*/_react.default.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M17.819 7.085a.582.582 0 00-.845-.052.646.646 0 00-.05.882l2.837 3.335h-8.492c-.33 0-.598.28-.598.625s.268.625.598.625h8.705l-3.05 3.585a.646.646 0 00.05.882.582.582 0 00.845-.052L22 12 17.82 7.085z"
        }));
      }
    case 'sound':
      {
        return /*#__PURE__*/_react.default.createElement(_components.BaseSvg, _extends({
          size: size,
          viewBoxSize: 24,
          className: (0, _classnames.default)('fill-current', className)
        }, props), /*#__PURE__*/_react.default.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M18.871 2c-.235 0-.477.06-.687.193l-9.286 5.41-3.082.342C4.794 8.03 4 8.653 4 9.445v5.016c0 .766.794 1.417 1.816 1.502l3.082.34 9.286 5.41c.21.135.455.194.694.194.575 0 1.122-.345 1.122-.845V2.845c-.027-.5-.563-.845-1.129-.845zm-.242 1.513v16.88l-9.038-5.267a1.389 1.389 0 00-.542-.18l-3.118-.342c-.307-.026-.497-.147-.56-.212V9.506c.058-.057.238-.175.596-.205l3.082-.34c.191-.022.376-.082.542-.18l9.038-5.268z"
        }));
      }
    case 'sound-mute':
      {
        return /*#__PURE__*/_react.default.createElement(_components.BaseSvg, _extends({
          size: size,
          viewBoxSize: 24,
          className: (0, _classnames.default)('fill-current', className)
        }, props), /*#__PURE__*/_react.default.createElement("g", {
          clipPath: "url(#clip0)",
          fillRule: "evenodd",
          clipRule: "evenodd"
        }, /*#__PURE__*/_react.default.createElement("path", {
          d: "M20.304 2.85v12.67l-1.37-1.29-7.03-6.62-1.03-.98 7.61-4.44c.21-.13.45-.19.69-.19.56 0 1.1.35 1.13.85zM23.864 20.93c-.1.11-.23.16-.37.16a.503.503 0 01-.34-.13L4.474 3.35a.504.504 0 01-.02-.71c.03-.03.07-.06.11-.07.02-.02.05-.03.08-.05h.01c.02-.01.03-.01.05-.01a.51.51 0 01.13-.02h.02a.5.5 0 01.12.02c.01 0 .01 0 .02.01.06.02.12.06.17.1l18.68 17.61c.2.19.21.5.02.7zM20.304 19.64v1.42c0 .5-.55.85-1.13.85-.24 0-.48-.06-.69-.2l-9.29-5.41-3.08-.34c-1.02-.08-1.81-.73-1.81-1.5V9.45c0-.8.79-1.42 1.81-1.5l1.59-.18L9.003 9l9.93 9.35 1.37 1.29z"
        })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
          id: "clip0"
        }, /*#__PURE__*/_react.default.createElement("path", {
          fill: "#fff",
          d: "M0 0h24v24H0z"
        }))));
      }
    case 'ellipse':
      {
        return /*#__PURE__*/_react.default.createElement(_components.BaseSvg, _extends({
          size: size,
          viewBoxSize: 24,
          className: (0, _classnames.default)('fill-current', className)
        }, props), /*#__PURE__*/_react.default.createElement("circle", {
          cx: "4",
          cy: "12",
          r: "2"
        }), /*#__PURE__*/_react.default.createElement("circle", {
          cx: "12",
          cy: "12",
          r: "2"
        }), /*#__PURE__*/_react.default.createElement("circle", {
          cx: "20",
          cy: "12",
          r: "2"
        }));
      }
    case 'lock':
      {
        return /*#__PURE__*/_react.default.createElement(_components.BaseSvg, _extends({
          size: size,
          viewBoxSize: 24,
          className: (0, _classnames.default)('fill-current', className)
        }, props), /*#__PURE__*/_react.default.createElement("path", {
          fillRule: "evenodd",
          d: "M3.89167 13.1975H12.1083V7.8575H3.89167V13.1975ZM5.41667 5.1125C5.41667 3.8375 6.575 2.8025 8 2.8025C9.425 2.8025 10.5833 3.8375 10.5833 5.1125V7.055H5.41667V5.1125ZM12.55 7.055H11.475V5.1125C11.475 3.395 9.91667 2 8 2C6.08333 2 4.525 3.395 4.525 5.1125V7.055H3.45C3.2 7.055 3 7.235 3 7.46V13.6025C3 13.82 3.2 14 3.45 14H12.55C12.8 14 13 13.82 13 13.6025V7.46C13 7.235 12.8 7.055 12.55 7.055Z"
        }));
      }
    case 'hash':
      {
        return /*#__PURE__*/_react.default.createElement(_components.BaseSvg, _extends({
          size: size,
          viewBoxSize: 24,
          className: (0, _classnames.default)('fill-current', className)
        }, props), /*#__PURE__*/_react.default.createElement("path", {
          d: "M5.66898 14L6.13692 10.6638H9.11785L8.64991 14H9.96707L10.435 10.6638H12.4627V9.49345H10.591L11.0243 6.41921H13V5.24891H11.1976L11.6482 2H10.331L9.88042 5.24891H6.89948L7.35009 2H6.03293L5.58232 5.24891H3.53726V6.41921H5.40901L4.97574 9.49345H3V10.6638H4.81976L4.35182 14H5.66898ZM9.27383 9.49345H6.29289L6.72617 6.41921H9.70711L9.27383 9.49345Z"
        }));
      }
    case 'green-dot':
      {
        return /*#__PURE__*/_react.default.createElement(_components.BaseSvg, _extends({
          size: size,
          viewBoxSize: 8,
          className: className
        }, props), /*#__PURE__*/_react.default.createElement("circle", {
          cx: "4",
          cy: "4",
          r: "4",
          fill: "#30966F"
        }));
      }
    case 'white-dot':
      {
        return /*#__PURE__*/_react.default.createElement(_components.BaseSvg, _extends({
          size: size,
          viewBoxSize: 8,
          className: className
        }, props), /*#__PURE__*/_react.default.createElement("circle", {
          cx: "4",
          cy: "4",
          r: "4",
          fill: "#FFFFFF"
        }));
      }
    case 'cloud-active':
      {
        return /*#__PURE__*/_react.default.createElement(_components.BaseSvg, _extends({
          className: className
        }, props), /*#__PURE__*/_react.default.createElement("path", {
          fillRule: "evenodd",
          d: "M0 8.13c0 3.65 4.04 6.63 9 6.63h.17c.23 0 .68.07 1.35.41 1.33.68 2.79 1.33 3.88 1.33.27 0 .53-.05.75-.14.25-.09.42-.28.47-.51.12-.5-.37-.99-.94-1.57-.2-.19-.48-.48-.62-.67C16.53 12.38 18 10.34 18 8.13c0-3.66-4.03-6.63-9-6.63-4.96 0-9 2.97-9 6.63z",
          fill: "#fff"
        }));
      }
    case 'cloud-inactive':
      {
        return /*#__PURE__*/_react.default.createElement(_components.BaseSvg, _extends({
          className: className
        }, props), /*#__PURE__*/_react.default.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M14.065 13.62c.13.19.42.48.62.67.56.57 1.05 1.06.94 1.57-.06.231-.23.41-.48.51-.22.09-.47.13-.74.13-1.1 0-2.55-.65-3.88-1.33-.67-.329-1.12-.4-1.36-.409h-.16c-.97 0-1.91-.111-2.79-.33a9.048 9.048 0 01-1.3-.401l-3.78 3.78a.767.767 0 01-.1.081.635.635 0 01-.22.099c-.05 0-.1.01-.15.01-.17 0-.34-.06-.47-.19a.676.676 0 010-.95l3.43-3.42 10.66-10.67L16.866.2c.13-.13.3-.2.47-.2a.676.676 0 01.469 1.15l-2.36 2.361c.33.25.632.509.9.79 1.04 1.08 1.66 2.409 1.66 3.84 0 2.209-1.48 4.25-3.94 5.479zM13.125 2.24L2.585 12.78c-1.6-1.2-2.58-2.84-2.58-4.64 0-3.66 4.04-6.64 9-6.64 1.48 0 2.88.261 4.12.74z",
          fill: "#fff"
        }));
      }
    case 'monument-logo':
      {
        return /*#__PURE__*/_react.default.createElement(_components.BaseSvg, _extends({
          className: (0, _classnames.default)('fill-current', className)
        }, props, {
          size: size,
          viewBoxSize: 32
        }), /*#__PURE__*/_react.default.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M31 10.7895V28H24.7705V10.4737C24.7705 10.1354 24.4944 9.8593 24.1475 9.84288L24.1148 9.84211H23.7869C23.4357 9.84211 23.149 10.108 23.132 10.4422L23.1311 10.4737V28H9.03279V10.4737C9.03279 10.1354 8.75673 9.8593 8.40978 9.84288L8.37705 9.84211H8.04918C7.698 9.84211 7.4113 10.108 7.39425 10.4422L7.39344 10.4737V28H1V10.8684C1 7.0751 4.19272 4 8.13115 4C12.0696 4 15.2623 7.0751 15.2623 10.8684V22.3374H16.9016V10.7895C16.9016 7.03975 20.0577 4 23.9508 4C27.844 4 31 7.03975 31 10.7895Z"
        }));
      }
    case 'beer-can':
      {
        return /*#__PURE__*/_react.default.createElement(_components.BaseSvg, _extends({
          size: size,
          viewBoxSize: 24,
          className: (0, _classnames.default)('fill-current', className)
        }, props), /*#__PURE__*/_react.default.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12.283 17.818H10.36a.469.469 0 0 0 0 .937h1.924a.469.469 0 0 0 0-.937ZM13.641 17.818h-.011a.469.469 0 0 0 0 .937h.011a.469.469 0 0 0 0-.937ZM12 15.68c-1.81 0-3.283-1.698-3.283-3.785 0-2.088 1.473-3.786 3.283-3.786 1.81 0 3.284 1.698 3.284 3.786 0 2.087-1.473 3.785-3.284 3.785Zm0-8.508c-2.327 0-4.22 2.119-4.22 4.723 0 2.604 1.893 4.722 4.22 4.722 2.328 0 4.221-2.118 4.221-4.722 0-2.604-1.893-4.723-4.22-4.723ZM15.761 4.09h-.011a.469.469 0 0 0 0 .937h.011a.469.469 0 0 0 0-.938Z"
        }), /*#__PURE__*/_react.default.createElement("mask", {
          id: "a",
          style: {
            maskType: 'alpha'
          },
          maskUnits: "userSpaceOnUse",
          x: "0",
          y: "23",
          width: "1",
          height: "1"
        }, /*#__PURE__*/_react.default.createElement("path", {
          d: "M0 23.063h.949V24H0v-.938Z",
          fill: "#fff"
        })), /*#__PURE__*/_react.default.createElement("g", {
          mask: "url(#a)"
        }, /*#__PURE__*/_react.default.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M.48 23.063H.469a.469.469 0 0 0 0 .937H.48a.469.469 0 0 0 0-.938Z"
        })), /*#__PURE__*/_react.default.createElement("mask", {
          id: "b",
          style: {
            maskType: 'alpha'
          },
          maskUnits: "userSpaceOnUse",
          x: "1",
          y: "0",
          width: "22",
          height: "24"
        }, /*#__PURE__*/_react.default.createElement("path", {
          d: "M1.358 0h21.285v24H1.358V0Z",
          fill: "#fff"
        })), /*#__PURE__*/_react.default.createElement("g", {
          mask: "url(#b)"
        }, /*#__PURE__*/_react.default.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M17.017 23.063H6.984c-.32-.001-.646-.71-.853-1.22h11.74c-.207.51-.534 1.219-.854 1.22ZM5.438 20.906V3.094h13.126v.996h-1.456a.469.469 0 0 0 0 .937h1.456v15.88H5.438ZM7.358.938h9.286l.956 1.218H6.4L7.358.938Zm14.816 22.125h-3.847c.22-.372.384-.79.52-1.136l.057-.148a.939.939 0 0 0 .596-.873V3.094a.937.937 0 0 0-.68-.901L17.828.929A.469.469 0 0 0 17.742 0H6.258a.469.469 0 0 0-.086.93l-.99 1.263a.939.939 0 0 0-.682.9v17.813c0 .397.248.736.597.873l.058.148c.135.346.3.764.518 1.136H1.827a.469.469 0 0 0 0 .937h20.347a.469.469 0 0 0 0-.937Z"
        })), /*#__PURE__*/_react.default.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M23.53 23.063h-.01a.469.469 0 0 0 0 .937h.01a.469.469 0 0 0 0-.938Z"
        }));
      }
    case 'beer-mug':
      {
        return /*#__PURE__*/_react.default.createElement(_components.BaseSvg, _extends({
          size: size,
          viewBoxSize: 24,
          className: (0, _classnames.default)('fill-current', className)
        }, props), /*#__PURE__*/_react.default.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M23.53 23.063h-.01a.469.469 0 0 0 0 .937h.01a.469.469 0 0 0 0-.938Z"
        }), /*#__PURE__*/_react.default.createElement("mask", {
          id: "a",
          style: {
            maskType: 'alpha'
          },
          maskUnits: "userSpaceOnUse",
          x: "0",
          y: "23",
          width: "1",
          height: "1"
        }, /*#__PURE__*/_react.default.createElement("path", {
          d: "M0 23.063h.949V24H0v-.938Z",
          fill: "#fff"
        })), /*#__PURE__*/_react.default.createElement("g", {
          mask: "url(#a)"
        }, /*#__PURE__*/_react.default.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M.48 23.063H.469a.469.469 0 0 0 0 .937H.48a.469.469 0 0 0 0-.938Z"
        })), /*#__PURE__*/_react.default.createElement("mask", {
          id: "b",
          style: {
            maskType: 'alpha'
          },
          maskUnits: "userSpaceOnUse",
          x: "0",
          y: "0",
          width: "24",
          height: "24"
        }, /*#__PURE__*/_react.default.createElement("path", {
          d: "M0 24h24V0H0v24Z",
          fill: "#fff"
        })), /*#__PURE__*/_react.default.createElement("g", {
          mask: "url(#b)"
        }, /*#__PURE__*/_react.default.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M11.532 7.125h3.75V5.25h-3.75v1.875Zm3.75 15.469a.47.47 0 0 1-.469.468H3.563a.47.47 0 0 1-.468-.468V8.062H4.97v3.282c0 .775.63 1.406 1.406 1.406.775 0 1.406-.63 1.406-1.406v-3.75a.469.469 0 0 1 .938 0v1.875c0 .775.63 1.406 1.406 1.406.775 0 1.406-.63 1.406-1.406V8.063h.938v1.454a.469.469 0 0 0 .937 0V8.063h1.875v14.53ZM3.094 7.125h1.875V5.25H3.094v1.875ZM4.51 3.094c.26 0 .47-.21.47-.469a1.686 1.686 0 0 1 3.108-.907c.137.213.42.278.637.147a1.385 1.385 0 0 1 1.832.357c.151.198.432.245.638.104.232-.158.502-.241.78-.241.522 0 .997.29 1.24.757a.47.47 0 0 0 .415.252h.233a1.42 1.42 0 0 1 1.403 1.219h-4.204a.469.469 0 0 0-.47.468V9.47a.469.469 0 0 1-.937 0V7.594c0-.776-.63-1.407-1.406-1.407-.775 0-1.406.631-1.406 1.407v3.75a.469.469 0 0 1-.938 0V4.78a.469.469 0 0 0-.468-.468h-2.33a1.42 1.42 0 0 1 1.403-1.22ZM16.22 19.547h2.344c.904 0 1.64-.736 1.64-1.64v-7.5c0-.905-.736-1.641-1.64-1.641h-2.344v-.704h2.344a2.347 2.347 0 0 1 2.343 2.344v7.5a2.347 2.347 0 0 1-2.343 2.344h-2.344v-.703Zm0-9.844h2.344c.38 0 .703.322.703.703v7.5a.713.713 0 0 1-.703.703h-2.344V9.703Zm5.955 13.36h-6.035c.051-.147.08-.305.08-.47v-1.405h2.344a3.285 3.285 0 0 0 3.28-3.282v-7.5a3.285 3.285 0 0 0-3.28-3.281h-2.344V4.511a2.358 2.358 0 0 0-2.324-2.355 2.325 2.325 0 0 0-2.865-.806A2.345 2.345 0 0 0 9.446.726c-.282 0-.56.051-.822.15A2.615 2.615 0 0 0 6.668 0a2.63 2.63 0 0 0-2.59 2.196 2.36 2.36 0 0 0-1.922 2.315v18.083c0 .164.03.322.081.468h-.41a.469.469 0 0 0 0 .938h20.347a.469.469 0 0 0 0-.938Z"
        })));
      }
    case 'cocktail':
      {
        return /*#__PURE__*/_react.default.createElement(_components.BaseSvg, _extends({
          size: size,
          viewBoxSize: 24,
          className: (0, _classnames.default)('fill-current', className)
        }, props), /*#__PURE__*/_react.default.createElement("g", {
          clipPath: "url(#a)",
          fillRule: "evenodd",
          clipRule: "evenodd"
        }, /*#__PURE__*/_react.default.createElement("path", {
          d: "M2.756 23.627a.378.378 0 0 1-.756 0c0-.212.171-.373.373-.373h.01c.212 0 .373.16.373.373ZM21.674 23.627a.38.38 0 0 1-.383.373.372.372 0 0 1-.373-.373c0-.212.161-.373.373-.373h.01c.202 0 .373.16.373.373ZM10.46 23.254l1.382-.867 1.381.867H10.46ZM8.907 12.646h5.86l-2.925 4.406-.09-.131-2.845-4.275ZM7.001 9.762h1.251a.371.371 0 0 0 .373-.363.373.373 0 0 0-.373-.374H6.507l-.595-.907h11.86l-2.512 3.781H8.413L7.001 9.762ZM16.944.736c.635 0 1.14.515 1.14 1.14 0 .635-.505 1.139-1.14 1.139a1.13 1.13 0 0 1-1.129-1.139c0-.625.504-1.14 1.13-1.14Zm2.985 22.518h-5.304l-.03-.02-2.39-1.493v-3.902l.02-.03 6.544-9.852a.373.373 0 0 0 .02-.384.364.364 0 0 0-.332-.191H13.96l2.451-3.691.07.01c.151.04.313.061.464.061a1.89 1.89 0 0 0 1.886-1.886A1.88 1.88 0 0 0 16.944 0a1.872 1.872 0 0 0-1.876 1.876 1.9 1.9 0 0 0 .616 1.402l.07.06-.05.071-2.642 3.973H5.216a.378.378 0 0 0-.333.191.401.401 0 0 0 .021.384l6.564 9.882v3.902l-2.42 1.513H3.744a.372.372 0 0 0-.373.373c0 .202.171.373.373.373H19.93a.378.378 0 0 0 .373-.373.372.372 0 0 0-.373-.373Z"
        }), /*#__PURE__*/_react.default.createElement("path", {
          d: "M9.986 9.398c0 .202-.16.363-.383.363a.361.361 0 0 1-.363-.363c0-.212.161-.373.363-.373h.02c.202 0 .363.161.363.373Z"
        })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
          id: "a"
        }, /*#__PURE__*/_react.default.createElement("path", {
          fill: "#fff",
          d: "M0 0h24v24H0z"
        }))));
      }
    case 'wineglass':
      {
        return /*#__PURE__*/_react.default.createElement(_components.BaseSvg, _extends({
          size: size,
          viewBoxSize: 24,
          className: (0, _classnames.default)('fill-current', className)
        }, props), /*#__PURE__*/_react.default.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M10.596 12.535c-2.201-.601-3.587-3.006-3.72-6.431l-.02-.366.336.142c.612.265 1.264.489 1.947.673 1.161.306 2.242.458 3.281.601l.214.031c1.182.153 2.405.326 3.404.754l.173.081-.04.184c-.286 1.386-.826 2.486-1.611 3.271a3.959 3.959 0 0 1-2.843 1.192c-.387 0-.774-.04-1.121-.132Zm-3.72-7.878c.051-1.192.245-2.415.561-3.638l.051-.173 8.255.041.05.163c.398 1.498.612 3.057.612 4.525 0 .499-.01.896-.041 1.263l-.02.306-.286-.112a8.162 8.162 0 0 0-1.141-.336l-.204-.041.031-.204c.041-.428.071-.927.092-1.376a.466.466 0 0 0-.102-.306.52.52 0 0 0-.306-.152c-.143 0-.224.04-.296.122-.091.071-.132.183-.142.306a14.82 14.82 0 0 1-.072 1.049l-.04.408-.235-.041-.418-.061c-.163-.02-.326-.051-.489-.071-1.702-.225-3.638-.479-5.727-1.458l-.133-.061v-.153Zm9.081 18.477-3.822-.01v-.225l-.041-9.396.204-.02a4.705 4.705 0 0 0 2.864-1.407c1.386-1.386 2.109-3.638 2.109-6.501a18.455 18.455 0 0 0-.795-5.239.423.423 0 0 0-.397-.316L7.162 0a.42.42 0 0 0-.408.295c-.448 1.488-.693 3.119-.744 4.719v.082C6 5.248 6 5.391 6 5.544c.02 4.158 1.661 7.073 4.382 7.806.194.051.408.092.662.133l.194.02v.204l.041 9.417-3.812-.021a.433.433 0 0 0-.438.428c0 .194.133.367.326.418.021.01.061.02.102.02l8.5.031a.447.447 0 0 0 .438-.428.449.449 0 0 0-.438-.438Z"
        }));
      }
    case 'logout':
      {
        return /*#__PURE__*/_react.default.createElement(_components.BaseSvg, _extends({
          size: size,
          viewBoxSize: 24,
          className: (0, _classnames.default)('fill-current', className)
        }, props), /*#__PURE__*/_react.default.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M13.1548 22H3.6276C2.73017 22 2 21.2426 2 20.3117V3.68831C2 2.7574 2.73017 2 3.6276 2H13.1548C13.5004 2 13.7808 2.29091 13.7808 2.64935C13.7808 3.00779 13.5004 3.2987 13.1548 3.2987H3.6276C3.42127 3.2987 3.252 3.47325 3.252 3.68831V20.3117C3.252 20.5268 3.42127 20.7013 3.6276 20.7013H13.1548C13.5004 20.7013 13.7808 20.9922 13.7808 21.3506C13.7808 21.7091 13.5004 22 13.1548 22Z"
        }), /*#__PURE__*/_react.default.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M17.8189 7.08495C17.5985 6.82695 17.2209 6.80395 16.9735 7.03295C16.7271 7.26195 16.7051 7.65695 16.9234 7.91495L19.761 11.25H11.2694C10.9389 11.25 10.6714 11.53 10.6714 11.875C10.6714 12.22 10.9389 12.5 11.2694 12.5H19.9743L16.9234 16.085C16.7051 16.343 16.7271 16.738 16.9735 16.967C17.2209 17.196 17.5985 17.173 17.8189 16.915L22.0005 12L17.8189 7.08495Z"
        }));
      }
    case 'employees':
      {
        return /*#__PURE__*/_react.default.createElement(_components.BaseSvg, _extends({
          size: size,
          viewBoxSize: 24,
          fill: "none",
          className: (0, _classnames.default)('stroke-current', className)
        }, props), /*#__PURE__*/_react.default.createElement("path", {
          d: "M9.5 11.5C10.6046 11.5 11.5 10.6046 11.5 9.5C11.5 8.39543 10.6046 7.5 9.5 7.5C8.39543 7.5 7.5 8.39543 7.5 9.5C7.5 10.6046 8.39543 11.5 9.5 11.5Z",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }), /*#__PURE__*/_react.default.createElement("path", {
          d: "M9.5 7.5C10.0304 7.5 10.5391 7.71071 10.9142 8.08579C11.2893 8.46086 11.5 8.96957 11.5 9.5C11.5 10.0304 11.2893 10.5391 10.9142 10.9142C10.5391 11.2893 10.0304 11.5 9.5 11.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }), /*#__PURE__*/_react.default.createElement("path", {
          d: "M13.9844 7.5C14.5148 7.5 15.0235 7.71071 15.3986 8.08579C15.7737 8.46086 15.9844 8.96957 15.9844 9.5C15.9844 10.0304 15.7737 10.5391 15.3986 10.9142C15.0235 11.2893 14.5148 11.5 13.9844 11.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }), /*#__PURE__*/_react.default.createElement("path", {
          d: "M13 16C13 15.4696 12.7893 14.9609 12.4142 14.5858C12.0391 14.2107 11.5304 14 11 14H8C7.46957 14 6.96086 14.2107 6.58579 14.5858C6.21071 14.9609 6 15.4696 6 16",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }), /*#__PURE__*/_react.default.createElement("path", {
          d: "M18 16C18 15.4696 17.7893 14.9609 17.4142 14.5858C17.0391 14.2107 16.5304 14 16 14H15",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }), /*#__PURE__*/_react.default.createElement("path", {
          d: "M16 3H8C5.23858 3 3 5.23858 3 8V16C3 18.7614 5.23858 21 8 21H16C18.7614 21 21 18.7614 21 16V8C21 5.23858 18.7614 3 16 3Z",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }));
      }
    case 'camera':
      {
        return /*#__PURE__*/_react.default.createElement(_components.BaseSvg, _extends({
          size: size,
          viewBoxSize: 24,
          fill: "none",
          className: (0, _classnames.default)('stroke-current', className)
        }, props), /*#__PURE__*/_react.default.createElement("path", {
          d: "M12.3846 8.5H8.61538C7.72323 8.5 7 9.22323 7 10.1154V13.8846C7 14.7768 7.72323 15.5 8.61538 15.5H12.3846C13.2768 15.5 14 14.7768 14 13.8846V10.1154C14 9.22323 13.2768 8.5 12.3846 8.5Z",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }), /*#__PURE__*/_react.default.createElement("path", {
          d: "M14 13.164L16.0089 14.4023C16.1074 14.463 16.2203 14.4963 16.336 14.4988C16.4516 14.5013 16.5658 14.4729 16.6669 14.4165C16.7679 14.3601 16.852 14.2778 16.9106 14.178C16.9691 14.0783 17 13.9647 17 13.849V10.151C17 10.0353 16.9691 9.9217 16.9106 9.82193C16.852 9.72217 16.7679 9.63984 16.6669 9.58344C16.5659 9.52705 16.4516 9.49863 16.336 9.50113C16.2203 9.50363 16.1074 9.53695 16.0089 9.59765L14 10.836",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }), /*#__PURE__*/_react.default.createElement("path", {
          d: "M16 3H8C5.23858 3 3 5.23858 3 8V16C3 18.7614 5.23858 21 8 21H16C18.7614 21 21 18.7614 21 16V8C21 5.23858 18.7614 3 16 3Z",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }));
      }
    case 'availability':
      {
        return /*#__PURE__*/_react.default.createElement(_components.BaseSvg, _extends({
          size: size,
          viewBoxSize: 24,
          fill: "none",
          className: (0, _classnames.default)('stroke-current', className)
        }, props), /*#__PURE__*/_react.default.createElement("path", {
          d: "M19 4H5C3.895 4 3 4.895 3 6V19C3 20.105 3.895 21 5 21H19C20.105 21 21 20.105 21 19V6C21 4.895 20.105 4 19 4Z",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }), /*#__PURE__*/_react.default.createElement("path", {
          d: "M16 3V6",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }), /*#__PURE__*/_react.default.createElement("path", {
          d: "M12 3V6",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }), /*#__PURE__*/_react.default.createElement("path", {
          d: "M8 3V6",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }), /*#__PURE__*/_react.default.createElement("path", {
          d: "M12 16H17",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }), /*#__PURE__*/_react.default.createElement("path", {
          d: "M8.63389 15.1161C9.12204 15.6043 9.12204 16.3957 8.63389 16.8839C8.14573 17.372 7.35428 17.372 6.86612 16.8839C6.37796 16.3957 6.37796 15.6043 6.86612 15.1161C7.35427 14.628 8.14573 14.628 8.63389 15.1161",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }), /*#__PURE__*/_react.default.createElement("path", {
          d: "M12 11H17",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }), /*#__PURE__*/_react.default.createElement("path", {
          d: "M8.63389 10.1161C9.12204 10.6043 9.12204 11.3957 8.63389 11.8839C8.14573 12.372 7.35428 12.372 6.86612 11.8839C6.37796 11.3957 6.37796 10.6043 6.86612 10.1161C7.35427 9.62796 8.14573 9.62796 8.63389 10.1161Z",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }));
      }
    case 'chat':
      {
        return /*#__PURE__*/_react.default.createElement(_components.BaseSvg, _extends({
          size: size,
          viewBoxSize: 24,
          fill: "none",
          className: (0, _classnames.default)('stroke-current', className)
        }, props), /*#__PURE__*/_react.default.createElement("path", {
          d: "M14 18L18 21V18H19C20.105 18 21 17.105 21 16V10C21 8.895 20.105 8 19 8H11C9.895 8 9 8.895 9 10V16C9 17.105 9.895 18 11 18H14Z",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }), /*#__PURE__*/_react.default.createElement("path", {
          d: "M9 15L6 17V14H5C3.895 14 3 13.105 3 12V6C3 4.895 3.895 4 5 4H14C15.105 4 16 4.895 16 6V8",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }));
      }
    case 'reviews':
      {
        return /*#__PURE__*/_react.default.createElement(_components.BaseSvg, _extends({
          size: size,
          viewBoxSize: 24,
          fill: "none",
          className: (0, _classnames.default)('stroke-current', className)
        }, props), /*#__PURE__*/_react.default.createElement("path", {
          d: "M19 21H5C3.895 21 3 20.105 3 19V5C3 3.895 3.895 3 5 3H19C20.105 3 21 3.895 21 5V19C21 20.105 20.105 21 19 21Z",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }), /*#__PURE__*/_react.default.createElement("path", {
          d: "M11.999 15.425L14.399 16.676C14.866 16.92 15.412 16.526 15.323 16.01L14.865 13.359L16.807 11.482C17.185 11.116 16.977 10.479 16.454 10.404L13.771 10.017L12.571 7.60299C12.337 7.13299 11.662 7.13299 11.429 7.60299L10.229 10.017L7.54599 10.404C7.02399 10.479 6.81499 11.117 7.19299 11.482L9.13499 13.359L8.67699 16.01C8.58799 16.526 9.13399 16.92 9.60099 16.676L12.001 15.425",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }));
      }
    case 'reviews-in-circle':
      {
        return /*#__PURE__*/_react.default.createElement(_components.BaseSvg, _extends({
          size: size,
          viewBoxSize: 24,
          fill: "none",
          className: (0, _classnames.default)('stroke-current', className)
        }, props), /*#__PURE__*/_react.default.createElement("path", {
          d: "M9.49652 11.5562L11.372 12.5412C11.7376 12.7339 12.1634 12.4224 12.0941 12.0163L11.7358 9.92834L13.2529 8.45083C13.5491 8.16361 13.3852 7.6612 12.9774 7.60268L10.8804 7.29835L9.94311 5.39766C9.76033 5.0276 9.23271 5.0276 9.05084 5.39766L8.11355 7.29835L6.01658 7.60268C5.60871 7.6621 5.44484 8.16361 5.74106 8.45083L7.25819 9.92834L6.89894 12.0172C6.82961 12.4233 7.25549 12.733 7.62104 12.5421L9.49652 11.5571",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }), /*#__PURE__*/_react.default.createElement("path", {
          d: "M15.2281 3.28572C18.447 6.50456 18.3921 11.7565 15.0634 14.906C11.9904 17.8133 7.00591 17.8133 3.93293 14.906C0.604243 11.7565 0.54932 6.50456 3.76816 3.28572C6.93298 0.120905 12.0633 0.120905 15.2281 3.28572",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }));
      }
    case 'settings-redesign':
      {
        return /*#__PURE__*/_react.default.createElement(_components.BaseSvg, _extends({
          size: size,
          viewBoxSize: 24,
          className: (0, _classnames.default)('fill-current', className)
        }, props), /*#__PURE__*/_react.default.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12 14.381C10.6324 14.381 9.51857 13.3123 9.51857 12.0001C9.51857 10.6879 10.6324 9.61913 12 9.61913C13.3675 9.61913 14.4814 10.6879 14.4814 12.0001C14.4814 13.3123 13.3675 14.381 12 14.381ZM12 8.66675C10.081 8.66675 8.526 10.1588 8.526 12.0001C8.526 13.8414 10.081 15.3334 12 15.3334C13.9189 15.3334 15.474 13.8414 15.474 12.0001C15.474 10.1588 13.9189 8.66675 12 8.66675Z"
        }), /*#__PURE__*/_react.default.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M20.9441 15.2275L19.3891 17.8201C19.2568 18.0212 18.9921 18.1058 18.7715 18.0212L17.2055 17.418C16.7643 17.2487 16.235 17.3016 15.8159 17.5661C15.5843 17.7143 15.3527 17.8413 15.11 17.9577C14.6579 18.1799 14.3491 18.582 14.2829 19.037L14.0403 20.6455C14.0072 20.8783 13.7976 21.0476 13.555 21.0476H10.445C10.2024 21.0476 9.99281 20.8783 9.95973 20.6455L9.7171 19.037C9.65093 18.582 9.34213 18.1799 8.88996 17.9577C8.64733 17.8413 8.41573 17.7143 8.18413 17.5661C7.76505 17.3016 7.24671 17.2381 6.79454 17.418L5.22849 18.0212C4.99689 18.1058 4.73221 18.0212 4.61089 17.8201L3.05587 15.2381C2.93456 15.0265 2.9897 14.7619 3.17719 14.6243L4.93072 13.3122C5.06306 13.2063 5.14026 13.037 5.11821 12.8783C5.08512 12.6561 5.05204 12.328 5.05204 12C5.05204 11.672 5.08512 11.3439 5.11821 11.1217C5.14026 10.963 5.06306 10.7937 4.93072 10.6878L3.17719 9.37566C2.9897 9.2381 2.93456 8.97355 3.05587 8.77249L4.61089 6.17989C4.73221 5.97884 4.98586 5.89418 5.21746 5.97884L6.79454 6.58201C7.24671 6.7619 7.76505 6.69841 8.18413 6.43386C8.41573 6.28571 8.64733 6.15873 8.88996 6.04233C9.34213 5.82011 9.65093 5.41799 9.7171 4.96296L9.95973 3.3545C9.99281 3.12169 10.2024 2.95238 10.445 2.95238H13.555C13.7976 2.95238 14.0072 3.12169 14.0403 3.3545L14.2829 4.96296C14.3491 5.41799 14.6579 5.82011 15.11 6.04233C15.3527 6.15873 15.5843 6.28571 15.8159 6.42328C16.235 6.69841 16.7533 6.75132 17.2055 6.58201L18.7715 5.97884C19.0031 5.89418 19.2678 5.97884 19.3891 6.17989L20.9441 8.77249C21.0654 8.97355 21.0103 9.2381 20.8228 9.37566L19.0693 10.6878C18.9369 10.7937 18.8597 10.963 18.8818 11.1217C18.9149 11.3651 18.948 11.672 18.948 12C18.948 12.328 18.9149 12.6349 18.8818 12.8783C18.8597 13.037 18.9369 13.2063 19.0693 13.3122L20.8228 14.6243C21.0103 14.7619 21.0654 15.0265 20.9441 15.2275ZM19.8964 12.7196L19.9185 12.5503C19.9295 12.3704 19.9405 12.1799 19.9405 12C19.9405 11.8201 19.9295 11.6296 19.9185 11.4497L19.8964 11.2804L21.4294 10.127C22.0139 9.69312 22.1683 8.89947 21.8044 8.28571L20.2493 5.7037C19.8744 5.10053 19.0803 4.83598 18.4076 5.10053L16.8415 5.7037C16.7643 5.73545 16.5879 5.7672 16.3673 5.64021C16.1026 5.4709 15.8379 5.32275 15.5622 5.18519C15.3968 5.11111 15.2865 4.97354 15.2644 4.8254L15.0218 3.22751C14.9226 2.5291 14.2939 2 13.555 2H10.445C9.7171 2 9.07744 2.5291 8.97819 3.22751L8.73556 4.8254C8.7135 4.97354 8.60322 5.11111 8.43779 5.18519C8.17311 5.32275 7.90842 5.4709 7.63271 5.64021C7.47831 5.73545 7.32391 5.75661 7.16951 5.7037L5.59243 5.10053C4.90866 4.83598 4.12564 5.08995 3.75067 5.7037L2.19565 8.28571C1.83171 8.89947 1.98611 9.69312 2.57062 10.127L4.10358 11.2804L4.08153 11.4497C4.0705 11.6296 4.05947 11.8201 4.05947 12C4.05947 12.1799 4.0705 12.3704 4.08153 12.5503L4.10358 12.7196L2.57062 13.873C1.98611 14.3069 1.83171 15.1005 2.19565 15.7037L3.75067 18.2963C4.12564 18.8995 4.90866 19.164 5.59243 18.8995L7.16951 18.2963C7.22465 18.2751 7.2798 18.2646 7.33494 18.2646C7.45625 18.2646 7.56654 18.3175 7.64374 18.3704C7.90842 18.5291 8.17311 18.6878 8.43779 18.8148C8.61425 18.8995 8.7135 19.0265 8.73556 19.1746L8.97819 20.7725C9.07744 21.4709 9.7171 22 10.445 22H13.555C14.2939 22 14.9226 21.4709 15.0218 20.7725L15.2644 19.1746C15.2865 19.0265 15.3968 18.8889 15.5622 18.8148C15.8379 18.6772 16.1026 18.5291 16.3673 18.3598C16.4666 18.2963 16.6651 18.2222 16.8525 18.3069L18.4076 18.8995C19.0803 19.164 19.8744 18.9101 20.2493 18.2963L21.8044 15.7037C22.1683 15.1005 22.0139 14.3069 21.4294 13.873L19.8964 12.7196Z"
        }));
      }
    case 'favorite':
      {
        return /*#__PURE__*/_react.default.createElement(_components.BaseSvg, _extends({
          size: size,
          viewBoxSize: 24,
          className: (0, _classnames.default)('fill-current', className)
        }, props), /*#__PURE__*/_react.default.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12 19.059c-1.298 0-8.053-3.916-8.053-9.177 0-2.38 1.829-4.94 4.548-4.94 1.572 0 2.577.78 3.145 1.449.18.207.54.207.72 0 .568-.66 1.573-1.45 3.145-1.45 2.72 0 4.548 2.56 4.548 4.941 0 5.261-6.755 9.177-8.053 9.177ZM15.505 4c-1.288 0-2.406.424-3.344 1.252l-.161.14-.161-.14C10.91 4.424 9.783 4 8.495 4 5.207 4 3 7.04 3 9.882 3 15.7 10.115 20 12 20c1.885 0 9-4.301 9-10.118C21 7.04 18.793 4 15.505 4Z"
        }));
      }
    case 'settings':
      {
        return /*#__PURE__*/_react.default.createElement(_components.BaseSvg, _extends({
          size: size,
          viewBoxSize: 24,
          className: (0, _classnames.default)('fill-current', className)
        }, props), /*#__PURE__*/_react.default.createElement("path", {
          d: "M14.2976 9.74414C13.9966 9.44945 13.6385 9.21493 13.2436 9.05399C12.8488 8.89304 12.425 8.80883 11.9964 8.80615C11.1316 8.81461 10.3049 9.15156 9.69521 9.74414C9.24063 10.1837 8.93116 10.7436 8.80592 11.3531C8.68067 11.9625 8.74528 12.5942 8.99157 13.1681C9.23786 13.7421 9.65478 14.2327 10.1896 14.5778C10.7245 14.923 11.3532 15.1072 11.9964 15.1072C12.6396 15.1072 13.2684 14.923 13.8032 14.5778C14.3381 14.2327 14.755 13.7421 15.0013 13.1681C15.2476 12.5942 15.3122 11.9625 15.1869 11.3531C15.0617 10.7436 14.7522 10.1837 14.2976 9.74414V9.74414ZM13.4043 13.3272C13.1775 13.5615 12.8935 13.7372 12.5784 13.8383C12.2633 13.9395 11.9269 13.9629 11.6001 13.9063C11.2732 13.8498 10.9661 13.7152 10.7069 13.5147C10.4477 13.3143 10.2444 13.0543 10.1158 12.7586C9.98711 12.4629 9.93708 12.1407 9.97024 11.8215C10.0034 11.5024 10.1187 11.1963 10.3056 10.9311C10.4926 10.666 10.7452 10.4502 11.0405 10.3035C11.3358 10.1568 11.6644 10.0838 11.9964 10.0912C12.2583 10.0885 12.518 10.1369 12.7599 10.2336C13.0019 10.3303 13.2211 10.4733 13.4043 10.654C13.7632 11.0126 13.9639 11.4918 13.9639 11.9906C13.9639 12.4894 13.7632 12.9687 13.4043 13.3272Z"
        }), /*#__PURE__*/_react.default.createElement("path", {
          d: "M19.2012 12.5581H19.1527V12.5112C19.162 12.3425 19.162 12.1734 19.1527 12.0047C19.162 11.836 19.162 11.6669 19.1527 11.4982V11.4513H19.2012L20.4246 10.5133C20.7084 10.2952 20.9024 9.98657 20.9718 9.64274C21.0412 9.29892 20.9815 8.94245 20.8033 8.63735L19.4245 6.33928C19.2431 6.03888 18.9563 5.81123 18.616 5.69765C18.2758 5.58407 17.9046 5.59207 17.57 5.72021L16.1912 6.25486H16.1135C16.0592 6.2669 16.0028 6.2669 15.9484 6.25486C15.7131 6.10546 15.47 5.96771 15.2202 5.84215C15.1823 5.82541 15.1486 5.80074 15.1218 5.76992C15.0949 5.7391 15.0755 5.7029 15.0648 5.66393L14.8512 4.24757C14.8019 3.90115 14.6241 3.58378 14.3509 3.35436C14.0777 3.12495 13.7276 2.99906 13.3656 3.00005H10.6372C10.2872 2.9972 9.94705 3.1115 9.67445 3.32354C9.40186 3.53557 9.21368 3.83225 9.1419 4.16315L8.938 5.57951C8.92769 5.62112 8.90737 5.65979 8.87869 5.69239C8.85001 5.72498 8.81378 5.75058 8.77293 5.76711C8.52637 5.88947 8.28654 6.0241 8.05441 6.17044C8.00522 6.20242 7.94842 6.22179 7.88934 6.22672H7.81167L6.43288 5.67331C6.09124 5.54854 5.71443 5.54721 5.37185 5.66959C5.02928 5.79197 4.74402 6.0298 4.56861 6.33928L3.19953 8.58107C3.01937 8.88568 2.9585 9.24269 3.02801 9.58703C3.09751 9.93138 3.29278 10.2401 3.57821 10.457L4.80164 11.395V11.4419C4.76284 11.7786 4.76284 12.1183 4.80164 12.455V12.5018L3.57821 13.4398C3.29278 13.6567 3.09751 13.9655 3.02801 14.3098C2.9585 14.6542 3.01937 15.0112 3.19953 15.3158L4.56861 17.6045C4.70343 17.8244 4.89518 18.0067 5.12502 18.1333C5.35485 18.2599 5.61484 18.3266 5.87942 18.3267C6.06888 18.3252 6.25645 18.2903 6.43288 18.2236L7.81167 17.6889H7.88934C7.94444 17.6914 7.99796 17.7075 8.0447 17.7358C8.27851 17.8928 8.52533 18.0308 8.78264 18.1485C8.82088 18.1673 8.85452 18.1937 8.88131 18.2261C8.90811 18.2585 8.92743 18.296 8.938 18.3361L9.1419 19.7525C9.1951 20.0973 9.37398 20.4124 9.64633 20.6411C9.91869 20.8698 10.2666 20.9971 10.6275 21H13.3656C13.7271 20.999 14.0761 20.8724 14.3488 20.6434C14.6216 20.4143 14.7999 20.0981 14.8512 19.7525L15.0648 18.3361C15.0755 18.2972 15.0949 18.261 15.1218 18.2301C15.1486 18.1993 15.1823 18.1746 15.2202 18.1579C15.47 18.0323 15.7131 17.8946 15.9484 17.7452C15.9976 17.7144 16.0549 17.6981 16.1135 17.6983H16.1912L17.57 18.2329C17.9046 18.3611 18.2758 18.3691 18.616 18.2555C18.9563 18.1419 19.2431 17.9143 19.4245 17.6139L20.8033 15.3252C20.9815 15.0201 21.0412 14.6636 20.9718 14.3198C20.9024 13.976 20.7084 13.6673 20.4246 13.4492L19.2012 12.5581ZM19.7061 14.7812L18.337 17.0323C18.3144 17.0651 18.2843 17.0924 18.2489 17.1119C18.2135 17.1314 18.1738 17.1427 18.1331 17.1449C18.1016 17.1549 18.0676 17.1549 18.036 17.1449L16.6572 16.6102C16.4842 16.5436 16.2998 16.5086 16.1135 16.507C15.8047 16.5091 15.5037 16.6006 15.2493 16.7697C15.0596 16.8916 14.8618 17.0013 14.657 17.098C14.4346 17.2034 14.2418 17.3591 14.0947 17.5517C13.9477 17.7444 13.8508 17.9684 13.8123 18.2048L13.6084 19.6212C13.5973 19.6758 13.5672 19.7252 13.523 19.761C13.4788 19.7969 13.4233 19.817 13.3656 19.8181H10.6275C10.571 19.8167 10.5168 19.7962 10.4742 19.7602C10.4317 19.7242 10.4035 19.6751 10.3945 19.6212L10.1808 18.1954C10.1435 17.9622 10.048 17.7413 9.9025 17.5517C9.75702 17.3621 9.56595 17.2096 9.34581 17.1074C9.15161 17.0042 8.94771 16.8916 8.7438 16.7603C8.49081 16.5969 8.19369 16.5088 7.88934 16.507C7.70305 16.5086 7.51867 16.5436 7.3456 16.6102L5.96681 17.1449C5.93497 17.1528 5.90156 17.1528 5.86972 17.1449C5.82846 17.1452 5.78784 17.135 5.75201 17.1152C5.71619 17.0955 5.68644 17.0668 5.66581 17.0323L4.29674 14.7812C4.2662 14.7347 4.25522 14.6786 4.26605 14.6246C4.27688 14.5705 4.3087 14.5225 4.35499 14.4904L5.89884 13.3179C6.00041 13.2549 6.08042 13.1643 6.1288 13.0575C6.17718 12.9507 6.19176 12.8324 6.17072 12.7176C6.1218 12.4697 6.08937 12.2191 6.07362 11.9672C6.08937 11.7153 6.1218 11.4647 6.17072 11.2168C6.18628 11.1129 6.17289 11.0068 6.13193 10.9096C6.09097 10.8123 6.02392 10.7273 5.93768 10.6634L4.35499 9.49091C4.3087 9.45878 4.27688 9.41077 4.26605 9.35671C4.25522 9.30265 4.2662 9.24663 4.29674 9.20014L5.66581 6.90207C5.68872 6.86745 5.72031 6.83897 5.75765 6.81929C5.795 6.79961 5.83689 6.78937 5.87942 6.78952C5.9044 6.7801 5.93213 6.7801 5.9571 6.78952L7.3456 7.32417C7.51867 7.39078 7.70305 7.42576 7.88934 7.42735C8.19343 7.42398 8.49008 7.33606 8.7438 7.17409C8.93837 7.05167 9.1393 6.93897 9.34581 6.83641C9.56569 6.73131 9.75627 6.5768 9.90156 6.38585C10.0469 6.1949 10.1426 5.97307 10.1808 5.73897L10.3945 4.31323C10.4038 4.25774 10.4334 4.20733 10.4779 4.17118C10.5225 4.13502 10.579 4.11553 10.6372 4.11626H13.3656C13.4233 4.11736 13.4788 4.13751 13.523 4.17335C13.5672 4.20918 13.5973 4.25855 13.6084 4.31323L13.8123 5.72959C13.8508 5.96602 13.9477 6.19002 14.0947 6.38267C14.2418 6.57531 14.4346 6.73094 14.657 6.83641C14.8606 6.93518 15.0583 7.04478 15.2493 7.16471C15.5046 7.33097 15.8057 7.41921 16.1135 7.41797C16.2992 7.41959 16.4836 7.38778 16.6572 7.32417L18.036 6.78952C18.0645 6.78087 18.095 6.78087 18.1234 6.78952C18.1661 6.78846 18.2084 6.79831 18.2459 6.81807C18.2834 6.83784 18.3148 6.86681 18.337 6.90207L19.7061 9.20014C19.7325 9.24768 19.7411 9.30257 19.7305 9.35554C19.7199 9.40851 19.6907 9.45632 19.6479 9.49091L18.104 10.6634C18.0189 10.7287 17.9521 10.8136 17.9097 10.9103C17.8673 11.0069 17.8506 11.1123 17.8613 11.2168C17.939 11.7143 17.939 12.2201 17.8613 12.7176C17.8506 12.8221 17.8673 12.9275 17.9097 13.0241C17.9521 13.1208 18.0189 13.2057 18.104 13.271L19.6479 14.4435C19.6755 14.4613 19.6991 14.4843 19.7171 14.5113C19.7352 14.5382 19.7473 14.5685 19.7528 14.6001C19.7582 14.6318 19.7569 14.6642 19.7489 14.6953C19.7408 14.7265 19.7263 14.7557 19.7061 14.7812V14.7812Z"
        }));
      }
    case 'microphone-on':
      {
        return /*#__PURE__*/_react.default.createElement(_components.BaseSvg, _extends({
          size: size,
          viewBoxSize: 24,
          className: (0, _classnames.default)('fill-current', className)
        }, props), /*#__PURE__*/_react.default.createElement("mask", {
          id: "mask0_5991_6063",
          style: {
            maskType: 'alpha'
          },
          maskUnits: "userSpaceOnUse",
          x: "4",
          y: "10",
          width: "16",
          height: "13"
        }, /*#__PURE__*/_react.default.createElement("path", {
          d: "M4 10.2961H20V22.9999H4V10.2961Z",
          fill: "white"
        })), /*#__PURE__*/_react.default.createElement("g", {
          mask: "url(#mask0_5991_6063)"
        }, /*#__PURE__*/_react.default.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M20 10.9671V11.8971C20 16.0381 16.893 19.4671 12.764 19.8601L12.671 19.8701V21.6571H15.097C15.458 21.6571 15.768 21.9671 15.768 22.3291C15.768 22.6901 15.458 23.0001 15.097 23.0001H8.903C8.532 23.0001 8.232 22.7001 8.232 22.3291C8.232 21.9571 8.532 21.6571 8.903 21.6571H11.329V19.8701L11.236 19.8601C7.107 19.4671 4 16.0381 4 11.8971V10.9671C4 10.5951 4.299 10.2961 4.671 10.2961C5.032 10.2961 5.342 10.6051 5.342 10.9671V11.8971C5.342 15.5741 8.325 18.5591 12 18.5591C15.675 18.5591 18.658 15.5741 18.658 11.8971V10.9671C18.658 10.5951 18.957 10.2961 19.329 10.2961C19.69 10.2961 20 10.6051 20 10.9671Z"
        })), /*#__PURE__*/_react.default.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M15.4582 12C15.4582 13.911 13.8992 15.46 12.0002 15.46C10.0902 15.46 8.5422 13.911 8.5422 12V5.803C8.5422 3.892 10.0902 2.343 12.0002 2.343C13.8992 2.343 15.4582 3.892 15.4582 5.803V12ZM12.0002 1C9.3472 1 7.2002 3.159 7.2002 5.803V12C7.2002 14.644 9.3472 16.803 12.0002 16.803C14.6432 16.803 16.8002 14.644 16.8002 12V5.803C16.8002 3.159 14.6432 1 12.0002 1Z"
        }));
      }
    case 'microphone-off':
      {
        return /*#__PURE__*/_react.default.createElement(_components.BaseSvg, _extends({
          size: size,
          viewBoxSize: 24,
          className: (0, _classnames.default)('fill-current', className)
        }, props), /*#__PURE__*/_react.default.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M19.6784 10.9671V11.8971C19.6784 12.9291 19.4824 13.9421 19.0794 14.9131C18.9764 15.1711 18.7394 15.3261 18.4604 15.3261C18.3784 15.3261 18.2954 15.3151 18.2124 15.2841C18.0474 15.2121 17.9134 15.0881 17.8414 14.9231C17.7794 14.7581 17.7794 14.5721 17.8414 14.4061C18.1714 13.6011 18.3364 12.7541 18.3364 11.8971V10.9671C18.3364 10.5951 18.6364 10.2961 19.0074 10.2961C19.3794 10.2961 19.6784 10.5951 19.6784 10.9671Z"
        }), /*#__PURE__*/_react.default.createElement("mask", {
          id: "mask0_5991_6064",
          style: {
            maskType: 'alpha'
          },
          maskUnits: "userSpaceOnUse",
          x: "7",
          y: "1",
          width: "10",
          height: "12"
        }, /*#__PURE__*/_react.default.createElement("path", {
          d: "M7.24902 1H16.4792V12.6718H7.24902V1Z",
          fill: "white"
        })), /*#__PURE__*/_react.default.createElement("g", {
          mask: "url(#mask0_5991_6064)"
        }, /*#__PURE__*/_react.default.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M16.4792 5.80276V11.9998C16.4792 12.3718 16.1802 12.6718 15.8082 12.6718C15.4372 12.6718 15.1372 12.3718 15.1372 11.9998V5.80276C15.1372 3.89176 13.5892 2.34276 11.6802 2.34276C10.3282 2.34276 9.08918 3.14876 8.53218 4.38776C8.42918 4.62576 8.18118 4.77976 7.92318 4.77976C7.83018 4.77976 7.73718 4.75976 7.64418 4.71876C7.47918 4.64576 7.35518 4.51176 7.29318 4.34676C7.23118 4.18076 7.23118 3.99476 7.31418 3.82976C8.08818 2.11576 9.80118 0.999756 11.6802 0.999756C14.3222 0.999756 16.4792 3.15876 16.4792 5.80276Z"
        })), /*#__PURE__*/_react.default.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M13.496 14.954C12.939 15.285 12.33 15.46 11.68 15.46C9.77 15.46 8.222 13.911 8.222 12V9.48997L13.61 14.882L13.496 14.954ZM20.153 19.53L17.284 16.658L15.075 14.448L8.026 7.39297L4.156 3.51997C4.032 3.39597 3.856 3.32397 3.681 3.32397C3.505 3.32397 3.33 3.39597 3.206 3.51997C3.072 3.64397 3 3.81997 3 3.99497C3 4.17097 3.072 4.34597 3.206 4.46997L6.88 8.14697V12C6.88 14.644 9.037 16.803 11.68 16.803C12.701 16.803 13.682 16.493 14.497 15.894L14.569 15.842L15.829 17.102L15.736 17.175C14.569 18.084 13.166 18.559 11.68 18.559C8.005 18.559 5.022 15.574 5.022 11.897V10.967C5.022 10.606 4.713 10.296 4.352 10.296C3.98 10.296 3.681 10.595 3.681 10.967V11.897C3.681 16.038 6.787 19.468 10.916 19.86L11.009 19.87V21.657H8.583C8.212 21.657 7.912 21.957 7.912 22.329C7.912 22.7 8.212 23 8.583 23H14.776C15.137 23 15.447 22.69 15.447 22.329C15.447 21.967 15.137 21.657 14.776 21.657H12.35V19.87L12.443 19.86C14.002 19.715 15.478 19.116 16.706 18.104L16.778 18.053L19.203 20.48C19.317 20.604 19.492 20.676 19.678 20.676C19.854 20.676 20.029 20.604 20.153 20.48C20.411 20.222 20.411 19.788 20.153 19.53Z"
        }));
      }
    case 'camera-on':
      {
        return /*#__PURE__*/_react.default.createElement(_components.BaseSvg, _extends({
          size: size,
          viewBoxSize: 24,
          className: (0, _classnames.default)('fill-current', className)
        }, props), /*#__PURE__*/_react.default.createElement("path", {
          d: "M21.1243 7.16091C20.8623 7.04317 20.5761 6.98836 20.2889 7.00091C19.9739 6.99844 19.6641 7.08142 19.3931 7.24091L16.9673 8.61091L16.8062 8.70091V8.52091C16.7594 7.56418 16.3409 6.66278 15.6389 6.0063C14.9368 5.34982 14.0058 4.98942 13.0418 5.00091H5.7846C4.80725 4.97937 3.86096 5.34255 3.15202 6.01129C2.44308 6.68004 2.02898 7.6001 2 8.57091V15.4309C2.02898 16.4017 2.44308 17.3218 3.15202 17.9905C3.86096 18.6593 4.80725 19.0224 5.7846 19.0009H13.0418C14.0076 19.015 14.9411 18.6558 15.6453 17.999C16.3496 17.3423 16.7694 16.4394 16.8163 15.4809V15.3009L16.9774 15.3909L19.3931 16.8009C19.6637 16.9613 19.9737 17.0444 20.2889 17.0409C20.5791 17.0388 20.865 16.9703 21.1243 16.8409C21.3831 16.7043 21.6007 16.5016 21.7545 16.2538C21.9084 16.006 21.9932 15.722 22 15.4309V8.57091C21.9932 8.27981 21.9084 7.99577 21.7545 7.74797C21.6007 7.50016 21.3831 7.29754 21.1243 7.16091V7.16091ZM15.4776 15.4309C15.4592 16.056 15.1928 16.6485 14.7365 17.0793C14.2803 17.5102 13.6711 17.7444 13.0418 17.7309H5.7846C5.47263 17.7389 5.16213 17.6857 4.87085 17.5744C4.57957 17.4631 4.31321 17.2959 4.087 17.0823C3.86079 16.8687 3.67917 16.613 3.5525 16.3296C3.42583 16.0462 3.3566 15.7409 3.34877 15.4309V8.57091C3.3566 8.26096 3.42583 7.95558 3.5525 7.67222C3.67917 7.38886 3.86079 7.13307 4.087 6.91948C4.31321 6.70588 4.57957 6.53867 4.87085 6.42738C5.16213 6.3161 5.47263 6.26293 5.7846 6.27091H13.0418C13.6711 6.25744 14.2803 6.49164 14.7365 6.92246C15.1928 7.35328 15.4592 7.94581 15.4776 8.57091V15.4309ZM20.6512 15.4309C20.6485 15.4906 20.6304 15.5486 20.5986 15.5993C20.5669 15.6501 20.5227 15.692 20.4701 15.7209C20.4107 15.7366 20.3482 15.7366 20.2889 15.7209C20.2202 15.7224 20.153 15.7013 20.0976 15.6609L16.8666 13.8409V10.1909L20.1077 8.31091C20.1669 8.29368 20.2297 8.29368 20.2889 8.31091C20.3452 8.29807 20.4037 8.29807 20.46 8.31091C20.5153 8.34022 20.5619 8.38327 20.5954 8.43585C20.629 8.48843 20.6482 8.54874 20.6512 8.61091V15.4309Z"
        }));
      }
    case 'camera-off':
      {
        return /*#__PURE__*/_react.default.createElement(_components.BaseSvg, _extends({
          size: size,
          viewBoxSize: 24,
          className: (0, _classnames.default)('fill-current', className)
        }, props), /*#__PURE__*/_react.default.createElement("path", {
          d: "M21.1289 7.13265C20.8683 7.0147 20.5836 6.95979 20.2978 6.97236C19.9848 6.97282 19.6775 7.05575 19.4067 7.2128L16.9936 8.58532L16.8434 8.67549V8.49516C16.7943 7.53579 16.3759 6.63269 15.6759 5.97524C14.9759 5.31779 14.0487 4.95706 13.0887 4.96867H5.8695C5.60717 4.96973 5.34559 4.99657 5.08851 5.04882L3.1961 2.25368C3.09024 2.12036 2.93771 2.03229 2.76938 2.00728C2.60106 1.98227 2.42952 2.02221 2.28952 2.11899C2.14952 2.21578 2.0515 2.36218 2.01533 2.52856C1.97916 2.69493 2.00753 2.86884 2.0947 3.01508L3.16606 4.59799L3.80688 5.59983L4.52779 6.6718L4.65796 6.87217L12.0373 17.7722H5.8695C5.24348 17.7857 4.6375 17.5511 4.18363 17.1195C3.72975 16.6878 3.46477 16.0942 3.44642 15.468V9.97788C3.42645 9.81526 3.34772 9.66556 3.22507 9.55699C3.10243 9.44843 2.94433 9.3885 2.78057 9.3885C2.61682 9.3885 2.45872 9.44843 2.33607 9.55699C2.21342 9.66556 2.1347 9.81526 2.11473 9.97788V15.458C2.15129 16.4226 2.56554 17.3342 3.26805 17.9958C3.97055 18.6575 4.90495 19.0162 5.8695 18.9945H12.8784L14.7207 21.7095C14.7822 21.7988 14.8645 21.8719 14.9604 21.9225C15.0563 21.9731 15.163 21.9997 15.2714 22C15.4074 21.9988 15.5399 21.957 15.6519 21.8798C15.7977 21.7786 15.8974 21.6237 15.9293 21.4491C15.9612 21.2745 15.9227 21.0943 15.8221 20.9481L15.2815 20.1366L14.3503 18.764L13.5993 17.662L13.4391 17.4216L12.6181 16.2194L5.89954 6.24101H13.0887C13.7147 6.22752 14.3207 6.46215 14.7745 6.89377C15.2284 7.32538 15.4934 7.919 15.5118 8.54525V14.4962L16.8535 15.2877L17.0938 15.4279L19.4067 16.7904C19.6764 16.9502 19.9845 17.0333 20.2978 17.0309C20.5865 17.0287 20.8709 16.9602 21.1289 16.8305C21.3863 16.6936 21.6027 16.4906 21.7558 16.2423C21.9089 15.9941 21.9932 15.7095 22 15.4179V8.54525C21.9932 8.25362 21.9089 7.96905 21.7558 7.72079C21.6027 7.47253 21.3863 7.26953 21.1289 7.13265V7.13265ZM20.6583 15.4179C20.6555 15.4777 20.6375 15.5358 20.606 15.5866C20.5744 15.6375 20.5304 15.6794 20.4781 15.7084C20.4229 15.7442 20.3586 15.7633 20.2928 15.7633C20.2271 15.7633 20.1628 15.7442 20.1076 15.7084L16.9035 13.835H16.8535V10.1682H16.9035L20.1176 8.28477C20.1764 8.26752 20.239 8.26752 20.2978 8.28477C20.3536 8.2699 20.4123 8.2699 20.4681 8.28477C20.523 8.31414 20.5694 8.35727 20.6028 8.40994C20.6361 8.46262 20.6553 8.52304 20.6583 8.58532V15.4179Z"
        }));
      }
    case 'leave-call':
      {
        return /*#__PURE__*/_react.default.createElement(_components.BaseSvg, _extends({
          size: size,
          viewBoxSize: 24,
          className: (0, _classnames.default)('fill-current', className)
        }, props), /*#__PURE__*/_react.default.createElement("path", {
          d: "M20.4507 5.48276C17.9335 3.79102 14.99 2.92789 12 3.00472C9.01038 2.93151 6.06792 3.79434 3.5493 5.48276C3.07147 5.82511 2.68061 6.28438 2.41063 6.82073C2.14065 7.35709 1.9997 7.95432 2 8.56064V9.54399C2 10.2351 2.26216 10.8979 2.7288 11.3866C3.19544 11.8753 3.82833 12.1499 4.48826 12.1499H5.96244C6.49785 12.1499 7.01134 11.9271 7.38993 11.5306C7.76853 11.1341 7.98122 10.5964 7.98122 10.0357V8.69831V8.62947H8.04695C9.30929 8.12476 10.6488 7.86486 12 7.86246C13.3505 7.83877 14.6937 8.07543 15.9624 8.56064H16.0188V10.0357C16.0188 10.5964 16.2315 11.1341 16.6101 11.5306C16.9887 11.9271 17.5021 12.1499 18.0376 12.1499H19.5117C20.1717 12.1499 20.8046 11.8753 21.2712 11.3866C21.7378 10.8979 22 10.2351 22 9.54399V8.56064C22.0011 7.95417 21.8605 7.35662 21.5905 6.82013C21.3204 6.28364 20.9291 5.8245 20.4507 5.48276ZM20.7793 9.54399C20.7769 9.89527 20.6425 10.2314 20.4053 10.4798C20.1682 10.7282 19.8472 10.8689 19.5117 10.8715H18.0376C17.9327 10.8715 17.829 10.8499 17.7321 10.8079C17.6353 10.7659 17.5473 10.7043 17.4732 10.6267C17.3991 10.5491 17.3403 10.4569 17.3002 10.3555C17.2601 10.2541 17.2394 10.1454 17.2394 10.0357V8.69831C17.2413 8.42147 17.1635 8.15047 17.0161 7.92067C16.8687 7.69086 16.6586 7.51294 16.4131 7.41012C13.5696 6.28227 10.4304 6.28227 7.58685 7.41012C7.34142 7.51294 7.13128 7.69086 6.98388 7.92067C6.83647 8.15047 6.75865 8.42147 6.76056 8.69831V10.0357C6.75812 10.2565 6.67325 10.4677 6.5241 10.6239C6.37495 10.7801 6.17336 10.869 5.96244 10.8715H4.48826C4.15283 10.8689 3.83184 10.7282 3.59465 10.4798C3.35745 10.2314 3.22311 9.89527 3.22066 9.54399V8.56064C3.23347 8.16875 3.33562 7.78575 3.51856 7.44362C3.70151 7.1015 3.95994 6.81016 4.2723 6.59394C6.57208 5.03743 9.26218 4.23299 12 4.28307C14.732 4.21542 17.4217 4.99919 19.7277 6.53494C20.0478 6.75681 20.311 7.0575 20.4943 7.41066C20.6777 7.76382 20.7755 8.15868 20.7793 8.56064V9.54399Z"
        }), /*#__PURE__*/_react.default.createElement("path", {
          d: "M16.6948 16.0439C16.694 16.2133 16.63 16.3757 16.5164 16.4963L12.3944 20.8132C12.338 20.8723 12.271 20.9191 12.1972 20.9508C12.1228 20.9833 12.043 21 11.9624 21C11.8819 21 11.8021 20.9833 11.7277 20.9508C11.6539 20.9191 11.5869 20.8723 11.5305 20.8132L7.446 16.4963C7.33145 16.3763 7.26709 16.2136 7.26709 16.0439C7.26709 15.8743 7.33145 15.7116 7.446 15.5916C7.56055 15.4716 7.71592 15.4042 7.87792 15.4042C8.03993 15.4042 8.19529 15.4716 8.30985 15.5916L11.23 18.6498L11.3897 18.817V11.5107C11.3897 11.3412 11.454 11.1786 11.5684 11.0587C11.6829 10.9389 11.8381 10.8715 12 10.8715C12.1619 10.8715 12.3171 10.9389 12.4316 11.0587C12.546 11.1786 12.6103 11.3412 12.6103 11.5107V18.817L12.7699 18.6498L15.6901 15.5916C15.7755 15.5021 15.8843 15.4411 16.0028 15.4163C16.1213 15.3916 16.2441 15.4043 16.3557 15.4527C16.4673 15.5011 16.5627 15.5832 16.6298 15.6884C16.6968 15.7937 16.7325 15.9174 16.7324 16.0439H16.6948Z"
        }), /*#__PURE__*/_react.default.createElement("path", {
          d: "M7.5495 15.4441H7.49316L7.58706 15.3851L7.5495 15.4441ZM15.7561 15.4441L15.85 15.3851L15.7561 15.4441ZM16.4134 15.4441L16.5072 15.5031L16.4134 15.4441Z"
        }));
      }
    case 'library-add-check':
      {
        return /*#__PURE__*/_react.default.createElement(_components.BaseSvg, {
          fill: "none",
          size: size,
          viewBoxSize: 24,
          className: (0, _classnames.default)('stroke-current', className)
        }, /*#__PURE__*/_react.default.createElement("path", {
          d: "M5 16C3.895 16 3 15.105 3 14V5C3 3.895 3.895 3 5 3H14C15.105 3 16 3.895 16 5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }), /*#__PURE__*/_react.default.createElement("path", {
          d: "M17.3893 13.0559L13.7783 16.6669L11.6113 14.4999",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }), /*#__PURE__*/_react.default.createElement("path", {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M19 21H10C8.895 21 8 20.105 8 19V10C8 8.895 8.895 8 10 8H19C20.105 8 21 8.895 21 10V19C21 20.105 20.105 21 19 21Z",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }));
      }
    case 'screenshare-on':
      {
        return /*#__PURE__*/_react.default.createElement(_components.BaseSvg, _extends({
          size: size,
          viewBoxSize: 24,
          className: (0, _classnames.default)('fill-current', className)
        }, props), /*#__PURE__*/_react.default.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M16.77 14.56C16.77 16.06 15.55 17.28 14.05 17.28H9.95C8.45 17.28 7.23 16.06 7.23 14.56V13.53C7.23 13.17 7.54 12.87 7.9 12.87C8.26 12.87 8.56 13.17 8.56 13.53V14.56C8.56 15.33 9.18 15.96 9.95 15.96H14.05C14.82 15.96 15.45 15.33 15.45 14.56V13.53C15.45 13.17 15.75 12.87 16.11 12.87C16.47 12.87 16.77 13.17 16.77 13.53V14.56ZM8.43 9.96L11.48 6.89C11.61 6.77 11.73 6.71 11.86 6.68H12.07C12.1 6.68 12.11 6.68 12.16 6.69C12.26 6.71 12.4 6.78 12.5 6.89L15.58 9.94C15.72 10.09 15.8 10.28 15.79 10.48C15.79 10.66 15.71 10.83 15.59 10.95L15.53 11C15.26 11.24 14.81 11.21 14.57 10.95L12.71 9.12V13.53C12.71 13.92 12.38 14.25 12 14.25C11.6 14.25 11.28 13.93 11.28 13.53V9.11L9.42 10.97C9.19 11.22 8.68 11.25 8.41 10.95C8.29 10.84 8.22 10.67 8.22 10.47C8.22 10.26 8.29 10.08 8.43 9.96ZM16.11 2H7.9C4.65 2 2 4.64 2 7.89V16.11C2 19.36 4.65 22 7.9 22H16.11C19.36 22 22 19.36 22 16.11V7.89C22 4.64 19.36 2 16.11 2Z"
        }));
      }
    case 'share':
      {
        return /*#__PURE__*/_react.default.createElement(_components.BaseSvg, _extends({
          size: size,
          viewBoxSize: 24,
          className: (0, _classnames.default)('fill-current', className)
        }, props), /*#__PURE__*/_react.default.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M20 12v6.632A2.362 2.362 0 0 1 17.647 21H6.353A2.362 2.362 0 0 1 4 18.632V12a2.362 2.362 0 0 1 2.353-2.368h1.882c.264 0 .47.208.47.473a.468.468 0 0 1-.47.474H6.353c-.781 0-1.412.635-1.412 1.421v6.632c0 .786.63 1.42 1.412 1.42h11.294c.781 0 1.412-.634 1.412-1.42V12c0-.786-.63-1.421-1.412-1.421h-1.882a.468.468 0 0 1-.47-.474c0-.265.206-.473.47-.473h1.882A2.362 2.362 0 0 1 20 12Z"
        }), /*#__PURE__*/_react.default.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M15.294 6.316a.446.446 0 0 1-.141.331.469.469 0 0 1-.33.142.468.468 0 0 1-.329-.142L12.47 4.62v9.275a.48.48 0 0 1-.47.473.48.48 0 0 1-.47-.473V4.62L9.505 6.647a.47.47 0 0 1-.659 0 .477.477 0 0 1 0-.663l2.824-2.842a.313.313 0 0 1 .15-.104.438.438 0 0 1 .377.01c.037.009.084.037.131.094l2.824 2.842a.446.446 0 0 1 .141.332Z"
        }));
      }
    case 'screenshare-off':
      {
        return /*#__PURE__*/_react.default.createElement(_components.BaseSvg, _extends({
          size: size,
          viewBoxSize: 24,
          className: (0, _classnames.default)('fill-current', className)
        }, props), /*#__PURE__*/_react.default.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M16.1056 2H7.89441C4.6448 2 2 4.6448 2 7.89441V16.1056C2 19.3552 4.6448 22 7.89441 22H16.1056C19.3552 22 22 19.3552 22 16.1056V7.89441C22 4.6448 19.3552 2 16.1056 2ZM16.1056 3.23014C18.6776 3.23014 20.7699 5.3224 20.7699 7.89441V16.1056C20.7699 18.6776 18.6776 20.7699 16.1056 20.7699H7.89441C5.3224 20.7699 3.23014 18.6776 3.23014 16.1056V7.89441C3.23014 5.3224 5.3224 3.23014 7.89441 3.23014H16.1056Z"
        }), /*#__PURE__*/_react.default.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M16.6181 13.5326V14.5577C16.6181 15.9724 15.4597 17.1307 14.0451 17.1307H9.94462C8.52997 17.1307 7.38184 15.9724 7.38184 14.5577V13.5326C7.38184 13.2558 7.61761 13.02 7.89439 13.02C8.17117 13.02 8.40695 13.2558 8.40695 13.5326V14.5577C8.40695 15.4085 9.09378 16.1056 9.94462 16.1056H14.0451C14.8959 16.1056 15.593 15.4085 15.593 14.5577V13.5326C15.593 13.2558 15.8288 13.02 16.1056 13.02C16.3823 13.02 16.6181 13.2558 16.6181 13.5326Z"
        }), /*#__PURE__*/_react.default.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M15.6338 10.4777C15.6338 10.6212 15.5723 10.7545 15.48 10.8468H15.4698C15.3673 10.9595 15.2237 11.021 15.0802 11.021C14.9265 11.021 14.7829 10.9595 14.6804 10.8468L12.7327 8.92979L12.5584 8.73502V13.5326C12.5584 13.8401 12.3022 14.0964 11.9946 14.0964C11.6871 14.0964 11.4308 13.8401 11.4308 13.5326V8.74527L9.30883 10.8673C9.21657 10.9698 9.0628 11.0313 8.91928 11.0313C8.76552 11.0313 8.622 10.9595 8.51949 10.8468C8.41698 10.7545 8.36572 10.6212 8.36572 10.4675C8.36572 10.3137 8.41698 10.1702 8.52974 10.0677L11.5846 6.99233C11.6871 6.90007 11.7794 6.84881 11.8819 6.82831H12.0664C12.0766 6.82831 12.0766 6.82831 12.1176 6.83856C12.1894 6.84881 12.3022 6.90007 12.3944 6.99233L15.4698 10.0472C15.5825 10.1599 15.644 10.3137 15.6338 10.4777Z"
        }));
      }
    case 'fullscreen':
      {
        return /*#__PURE__*/_react.default.createElement(_components.BaseSvg, _extends({
          size: size,
          viewBoxSize: 24,
          className: (0, _classnames.default)('fill-current', className)
        }, props), /*#__PURE__*/_react.default.createElement("path", {
          d: "M21.9998 13.1428V18.857C21.9998 19.6905 21.6687 20.4899 21.0793 21.0793C20.4899 21.6687 19.6905 21.9998 18.857 21.9998H5.14283C4.3093 21.9998 3.50991 21.6687 2.92051 21.0793C2.33112 20.4899 2 19.6905 2 18.857V5.14283C2 4.3093 2.33112 3.50991 2.92051 2.92051C3.50991 2.33112 4.3093 2 5.14283 2H10.8571C11.0844 2 11.3024 2.09031 11.4631 2.25105C11.6239 2.41179 11.7142 2.62981 11.7142 2.85714C11.7142 3.08446 11.6239 3.30248 11.4631 3.46322C11.3024 3.62397 11.0844 3.71427 10.8571 3.71427H5.14283C4.76395 3.71427 4.40059 3.86478 4.13268 4.13269C3.86478 4.40059 3.71427 4.76395 3.71427 5.14283V18.857C3.71427 19.2359 3.86478 19.5992 4.13268 19.8672C4.40059 20.1351 4.76395 20.2856 5.14283 20.2856H18.857C19.2359 20.2856 19.5992 20.1351 19.8671 19.8672C20.135 19.5992 20.2855 19.2359 20.2855 18.857V13.1428C20.2855 12.9154 20.3758 12.6974 20.5366 12.5367C20.6973 12.3759 20.9154 12.2856 21.1427 12.2856C21.37 12.2856 21.588 12.3759 21.7488 12.5367C21.9095 12.6974 21.9998 12.9154 21.9998 13.1428Z"
        }), /*#__PURE__*/_react.default.createElement("path", {
          d: "M22.0002 2.85714V7.42853C22.0002 7.65586 21.9099 7.87387 21.7492 8.03462C21.5884 8.19536 21.3704 8.28567 21.1431 8.28567C20.9158 8.28567 20.6978 8.19536 20.537 8.03462C20.3763 7.87387 20.286 7.65586 20.286 7.42853V4.9257L14.8917 10.3199C14.8126 10.4001 14.7182 10.4636 14.6142 10.5068C14.5102 10.5499 14.3986 10.5719 14.286 10.5714C14.1733 10.5725 14.0615 10.5509 13.9574 10.5077C13.8533 10.4645 13.7591 10.4006 13.6803 10.3199C13.5994 10.2411 13.5352 10.147 13.4913 10.0429C13.4474 9.9389 13.4248 9.82713 13.4248 9.71423C13.4248 9.60132 13.4474 9.48956 13.4913 9.38553C13.5352 9.2815 13.5994 9.18731 13.6803 9.10852L19.0745 3.71428H16.5717C16.3444 3.71428 16.1264 3.62397 15.9656 3.46323C15.8049 3.30248 15.7146 3.08447 15.7146 2.85714C15.7146 2.62981 15.8049 2.4118 15.9656 2.25105C16.1264 2.09031 16.3444 2 16.5717 2H21.1431C21.2571 1.99965 21.37 2.023 21.4745 2.06857C21.6814 2.1544 21.8458 2.31881 21.9317 2.52571C21.9772 2.63024 22.0006 2.74311 22.0002 2.85714V2.85714Z"
        }));
      }
    case 'fullscreen-exit':
      {
        return /*#__PURE__*/_react.default.createElement(_components.BaseSvg, _extends({
          size: size,
          viewBoxSize: 24,
          className: (0, _classnames.default)('fill-current', className)
        }, props), /*#__PURE__*/_react.default.createElement("path", {
          d: "M21.9845 13.1429V18.8571C21.9845 19.6907 21.6537 20.4901 21.0647 21.0795C20.4758 21.6689 19.677 22 18.8441 22H5.14043C4.30753 22 3.50875 21.6689 2.91981 21.0795C2.33087 20.4901 2 19.6907 2 18.8571V5.14286C2 4.30932 2.33087 3.50992 2.91981 2.92052C3.50875 2.33112 4.30753 2 5.14043 2H10.8503C11.0774 2 11.2953 2.09031 11.4559 2.25105C11.6165 2.4118 11.7068 2.62981 11.7068 2.85714C11.7068 3.08447 11.6165 3.30249 11.4559 3.46323C11.2953 3.62398 11.0774 3.71429 10.8503 3.71429H5.14043C4.76184 3.71429 4.39876 3.8648 4.13106 4.1327C3.86335 4.40061 3.71296 4.76398 3.71296 5.14286V18.8571C3.71296 19.236 3.86335 19.5994 4.13106 19.8673C4.39876 20.1352 4.76184 20.2857 5.14043 20.2857H18.8441C19.2227 20.2857 19.5858 20.1352 19.8535 19.8673C20.1212 19.5994 20.2716 19.236 20.2716 18.8571V13.1429C20.2716 12.9155 20.3618 12.6975 20.5224 12.5368C20.6831 12.376 20.9009 12.2857 21.1281 12.2857C21.3552 12.2857 21.5731 12.376 21.7337 12.5368C21.8943 12.6975 21.9845 12.9155 21.9845 13.1429Z"
        }), /*#__PURE__*/_react.default.createElement("path", {
          d: "M21.7334 3.46284L16.3433 8.85712H18.8442C19.0713 8.85712 19.2892 8.94743 19.4498 9.10817C19.6104 9.26892 19.7007 9.48694 19.7007 9.71426C19.7007 9.94159 19.6104 10.1596 19.4498 10.3204C19.2892 10.4811 19.0713 10.5714 18.8442 10.5714H14.2763C14.1624 10.5718 14.0496 10.5484 13.9451 10.5028C13.8409 10.4639 13.7471 10.4013 13.6711 10.32C13.5537 10.201 13.4742 10.0499 13.4427 9.88569C13.4371 9.82868 13.4371 9.77127 13.4427 9.71426V5.14284C13.4427 4.91551 13.5329 4.69749 13.6935 4.53674C13.8541 4.376 14.072 4.28569 14.2991 4.28569C14.5263 4.28569 14.7441 4.376 14.9048 4.53674C15.0654 4.69749 15.1556 4.91551 15.1556 5.14284V7.64569L20.5457 2.25141C20.7063 2.09089 20.924 2.00073 21.151 2.00073C21.3779 2.00073 21.5956 2.09089 21.7562 2.25141C21.8356 2.33172 21.898 2.42712 21.9399 2.53198C21.9818 2.63684 22.0023 2.74903 22.0002 2.86194C21.9981 2.97486 21.9733 3.0862 21.9275 3.1894C21.8817 3.2926 21.8157 3.38558 21.7334 3.46284V3.46284Z"
        }));
      }
    case 'video-bell':
      {
        return /*#__PURE__*/_react.default.createElement(_components.BaseSvg, _extends({
          size: size,
          viewBoxSize: 32,
          className: (0, _classnames.default)('fill-current', className)
        }, props), /*#__PURE__*/_react.default.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M17.836 29.15c0 .466-.364.85-.832.85h-6.007a.837.837 0 0 1-.832-.85c0-.466.364-.85.832-.85h6.007c.468 0 .832.384.832.85ZM23.684 22.698H4.318a2.649 2.649 0 0 1-2.655-2.647c0-1.003.555-1.91 1.458-2.363l.949-.48a2.443 2.443 0 0 0 1.355-2.194v-4.726c0-4.74 3.85-8.59 8.575-8.59s8.575 3.85 8.575 8.59v4.726c0 .934.525 1.784 1.357 2.194l.947.48a2.626 2.626 0 0 1 1.46 2.363 2.649 2.649 0 0 1-2.655 2.647Zm1.925-6.537-.948-.482a.72.72 0 0 1-.423-.665v-4.726C24.238 4.612 19.645 0 14 0 8.357 0 3.763 4.64 3.763 10.345v4.669a.773.773 0 0 1-.423.68l-.947.467A4.33 4.33 0 0 0 0 20.05c0 2.392 1.94 4.345 4.318 4.345h19.366c2.377 0 4.316-1.953 4.316-4.345a4.328 4.328 0 0 0-2.391-3.89Z"
        }));
      }
    case 'mail':
      {
        return /*#__PURE__*/_react.default.createElement(_components.BaseSvg, _extends({
          size: size,
          viewBoxSize: 48,
          className: (0, _classnames.default)('stroke-current', className),
          fill: "none"
        }, props), /*#__PURE__*/_react.default.createElement("path", {
          d: "M9.272 10.09h29.454A3.274 3.274 0 0 1 42 13.364v21.272a3.272 3.272 0 0 1-3.272 3.272H9.272A3.27 3.27 0 0 1 6 34.636V13.364a3.274 3.274 0 0 1 3.272-3.274Z",
          clipRule: "evenodd"
        }), /*#__PURE__*/_react.default.createElement("path", {
          d: "m6.238 12.15 15.388 11.006a4.002 4.002 0 0 0 4.65.004l15.476-11.038"
        }));
      }
    case 'menu-small':
      {
        return /*#__PURE__*/_react.default.createElement(_components.BaseSvg, _extends({
          size: size,
          viewBoxSize: 32,
          className: (0, _classnames.default)('fill-current', className)
        }, props), /*#__PURE__*/_react.default.createElement("path", {
          d: "M16.903 9.095H1.097A1.097 1.097 0 0 1 0 8a1.094 1.094 0 0 1 1.097-1.095h15.806A1.097 1.097 0 0 1 18 8a1.094 1.094 0 0 1-1.097 1.095ZM16.903 16H1.097A1.097 1.097 0 0 1 0 14.905a1.094 1.094 0 0 1 1.097-1.095h15.806A1.097 1.097 0 0 1 18 14.905 1.094 1.094 0 0 1 16.903 16ZM16.903 2.19H1.097A1.098 1.098 0 0 1 0 1.095 1.094 1.094 0 0 1 1.097 0h15.806A1.097 1.097 0 0 1 18 1.095a1.094 1.094 0 0 1-1.097 1.095Z"
        }));
      }
    case 'groups-menu':
      {
        return /*#__PURE__*/_react.default.createElement(_components.BaseSvg, _extends({
          size: size,
          viewBoxSize: 24,
          className: (0, _classnames.default)('fill-current', className)
        }, props), /*#__PURE__*/_react.default.createElement("path", {
          d: "M18.01 9.571a2.447 2.447 0 1 1 .01-4.895 2.447 2.447 0 0 1-.01 4.895Zm0-3.81a1.4 1.4 0 1 0-.076 2.799 1.4 1.4 0 0 0 .075-2.799ZM11 7.952a3.495 3.495 0 0 1-2.428-6 3.562 3.562 0 0 1 4.933 0 3.495 3.495 0 0 1-2.505 6Zm0-5.943a2.39 2.39 0 0 0-1.724.724 2.438 2.438 0 0 0 0 3.448 2.495 2.495 0 0 0 3.448 0 2.38 2.38 0 0 0 .714-1.724 2.4 2.4 0 0 0-.714-1.724A2.41 2.41 0 0 0 11 2.01ZM3.99 9.572a2.448 2.448 0 1 1 .07-4.895 2.448 2.448 0 0 1-.07 4.895Zm0-3.81c-.359.007-.7.154-.952.41a1.4 1.4 0 0 0 1.943 1.98 1.4 1.4 0 0 0-.99-2.39ZM21.476 15.343a.524.524 0 0 1-.524-.524V13.78a1.904 1.904 0 0 0-1.857-1.857h-.762a.524.524 0 0 1 0-1.048h.762A2.914 2.914 0 0 1 22 13.781v1.038a.523.523 0 0 1-.524.524ZM.524 15.343A.524.524 0 0 1 0 14.819V13.78a2.914 2.914 0 0 1 2.905-2.905h.762a.524.524 0 0 1 0 1.048h-.762a1.905 1.905 0 0 0-1.857 1.857v1.038a.524.524 0 0 1-.524.524ZM16.086 15.342a.515.515 0 0 1-.524-.523v-1.524a2.857 2.857 0 0 0-2.81-2.772H9.248a2.857 2.857 0 0 0-2.857 2.81v1.524a.524.524 0 1 1-1.048 0v-1.524a3.866 3.866 0 0 1 3.905-3.895h3.504a3.867 3.867 0 0 1 3.857 3.857v1.524a.525.525 0 0 1-.523.523Z"
        }));
      }
    case 'clinician-menu':
      {
        return /*#__PURE__*/_react.default.createElement(_components.BaseSvg, _extends({
          size: size,
          fill: "none",
          viewBoxSize: 24,
          className: (0, _classnames.default)('stroke-current', className)
        }, props), /*#__PURE__*/_react.default.createElement("path", {
          clipRule: "evenodd",
          d: "M11 2.996h4a2 2 0 0 1 2.002 2v4.002A4.002 4.002 0 0 1 13 13v0a4.002 4.002 0 0 1-4.002-4.002V4.997A2 2 0 0 1 11 2.996Z",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }), /*#__PURE__*/_react.default.createElement("path", {
          d: "m15.102 12.405.743 2.973M10.9 12.405l-.743 2.973M8.998 15.158v3.845",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }), /*#__PURE__*/_react.default.createElement("circle", {
          cx: "8.998",
          cy: "20.503",
          r: "1.501",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }), /*#__PURE__*/_react.default.createElement("path", {
          d: "M17.002 15.158v3.845M15.278 22.004a1.993 1.993 0 0 1-.277-1v0a2 2 0 0 1 2-2.002v0a2 2 0 0 1 2.002 2.001v0a1.993 1.993 0 0 1-.278 1M17.002 6.997H8.998",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }), /*#__PURE__*/_react.default.createElement("path", {
          d: "M3.996 20.003v-1.385c0-1.43 1.01-2.662 2.413-2.943l2.847-.57a.905.905 0 0 1 .68.135v0a5.522 5.522 0 0 0 6.128 0v0a.905.905 0 0 1 .68-.134l2.847.57a3.001 3.001 0 0 1 2.413 2.942v1.385",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }));
      }
    case 'reviews-menu':
      {
        return /*#__PURE__*/_react.default.createElement(_components.BaseSvg, _extends({
          size: size,
          fill: "none",
          viewBoxSize: 24,
          className: (0, _classnames.default)('stroke-current', className)
        }, props), /*#__PURE__*/_react.default.createElement("path", {
          d: "M16.747 6.187a7.467 7.467 0 1 1-10.56 10.56 7.467 7.467 0 0 1 10.56-10.56M20 20l-3.25-3.25",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }), /*#__PURE__*/_react.default.createElement("path", {
          clipRule: "evenodd",
          d: "M11.467 9.785c.23-.252.627-.535 1.232-.535 1.058 0 1.768.931 1.768 1.798 0 1.813-2.407 3.202-3 3.202s-3-1.389-3-3.202c0-.867.71-1.798 1.768-1.798.605 0 1.002.283 1.232.535Z",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }));
      }
    case 'templates':
      {
        return /*#__PURE__*/_react.default.createElement(_components.BaseSvg, _extends({
          size: size,
          fill: "none",
          viewBoxSize: 24,
          className: (0, _classnames.default)('stroke-current', className)
        }, props), /*#__PURE__*/_react.default.createElement("path", {
          d: "M16 18h2a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H9a2 2 0 0 0-2 2v2",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }), /*#__PURE__*/_react.default.createElement("path", {
          clipRule: "evenodd",
          d: "m15.36 9.47-1.83-1.83c-.41-.41-.967-.64-1.547-.64H6a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-7.983c0-.58-.23-1.136-.64-1.547Z",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }), /*#__PURE__*/_react.default.createElement("path", {
          d: "M16 11.5h-3a1.5 1.5 0 0 1-1.5-1.5V7",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }));
      }
    case 'calendar':
      {
        return /*#__PURE__*/_react.default.createElement(_components.BaseSvg, _extends({
          size: size,
          viewBoxSize: 24,
          className: (0, _classnames.default)('fill-current', className)
        }, props), /*#__PURE__*/_react.default.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M20.802 17.907a2.382 2.382 0 0 1-2.387 2.386H6.583a2.382 2.382 0 0 1-2.386-2.386V7.563a2.39 2.39 0 0 1 2.386-2.396h.907v.917c0 .305.266.562.572.562a.577.577 0 0 0 .572-.562v-.917h7.73v.917c0 .305.267.562.572.562a.577.577 0 0 0 .572-.562v-.917h.907a2.39 2.39 0 0 1 2.387 2.396v10.344ZM18.415 4.2h-1.074V3.125a.413.413 0 0 0-.405-.404.413.413 0 0 0-.404.404V4.2H8.466V3.125a.413.413 0 0 0-.404-.404.413.413 0 0 0-.404.404V4.2H6.583a3.367 3.367 0 0 0-3.362 3.363v10.344a3.367 3.367 0 0 0 3.362 3.363h11.832a3.367 3.367 0 0 0 3.363-3.363V7.563A3.367 3.367 0 0 0 18.415 4.2Z"
        }), /*#__PURE__*/_react.default.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M18.002 16.911a.572.572 0 0 1-.572.572H7.57a.572.572 0 0 1-.572-.572c0-.306.266-.562.572-.562h9.86c.306 0 .572.256.572.562ZM18.002 13.126a.572.572 0 0 1-.572.572H7.57a.572.572 0 0 1-.572-.572c0-.306.266-.562.572-.562h9.86c.306 0 .572.256.572.562ZM18.002 9.34a.572.572 0 0 1-.572.573H7.57a.572.572 0 0 1-.572-.572c0-.306.266-.562.572-.562h9.86c.306 0 .572.256.572.562Z"
        }));
      }
    case 'calendar-plus':
      {
        return /*#__PURE__*/_react.default.createElement(_components.BaseSvg, _extends({
          size: size,
          viewBoxSize: 40,
          fill: "none",
          className: (0, _classnames.default)('stroke-current', className)
        }, props), /*#__PURE__*/_react.default.createElement("path", {
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "1.5",
          d: "M25 5v3.333M11.667 5v3.333M5 13.333h26.667M31.667 20.695V10a3.332 3.332 0 0 0-3.334-3.333h-20A3.332 3.332 0 0 0 5 10v18.333a3.332 3.332 0 0 0 3.333 3.334h12.362"
        }), /*#__PURE__*/_react.default.createElement("path", {
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "1.5",
          d: "M11.666 17.917a.417.417 0 1 0 .004.833.417.417 0 0 0-.004-.833M11.666 24.583a.417.417 0 1 0 .003.833.417.417 0 0 0-.003-.833M17.917 18.335a.417.417 0 1 0 .833-.004.417.417 0 0 0-.833.004"
        }), /*#__PURE__*/_react.default.createElement("path", {
          strokeWidth: "1.5",
          d: "M28.333 36.667A8.333 8.333 0 0 1 20 28.333c0-4.506 3.833-8.338 8.34-8.333a8.333 8.333 0 0 1 8.327 8.333 8.333 8.333 0 0 1-8.334 8.334"
        }), /*#__PURE__*/_react.default.createElement("path", {
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "1.5",
          d: "M28.333 25v6.667M31.667 28.333H25"
        }));
      }
    case 'insurance':
      {
        return /*#__PURE__*/_react.default.createElement(_components.BaseSvg, _extends({
          size: size,
          viewBoxSize: 24,
          fill: "none",
          className: (0, _classnames.default)('stroke-current', className)
        }, props), /*#__PURE__*/_react.default.createElement("path", {
          strokeLinecap: "round",
          strokeLinejoin: "round",
          d: "M15.319 10.341 11.17 14.49 8.68 12"
        }), /*#__PURE__*/_react.default.createElement("path", {
          strokeLinecap: "round",
          strokeLinejoin: "round",
          d: "M19.1 5.92a11.268 11.268 0 0 1-6.463-2.688.989.989 0 0 0-1.274 0A11.275 11.275 0 0 1 4.9 5.92a.988.988 0 0 0-.9.992v4.33c0 4.366 3.156 8.461 7.478 9.684.339.097.706.097 1.045 0C16.844 19.704 20 15.61 20 11.244v-4.33a.988.988 0 0 0-.9-.993Z",
          clipRule: "evenodd"
        }));
      }
    case 'protection-shield':
      {
        return /*#__PURE__*/_react.default.createElement(_components.BaseSvg, _extends({
          size: size,
          viewBoxSize: 24,
          fill: "none",
          className: (0, _classnames.default)('stroke-current', className)
        }, props), /*#__PURE__*/_react.default.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M20 11.1821C20 15.7231 16.587 19.9691 12 21.0001C7.413 19.9691 4 15.7231 4 11.1821V7.61506C4 6.80306 4.491 6.07106 5.243 5.76406L10.243 3.71806C11.369 3.25706 12.631 3.25706 13.757 3.71806L18.757 5.76406C19.509 6.07206 20 6.80306 20 7.61506V11.1821V11.1821Z",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }), /*#__PURE__*/_react.default.createElement("path", {
          d: "M15.25 10.125L11.5 13.875L9.25 11.625",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }));
      }
    case 'appointments':
      {
        return /*#__PURE__*/_react.default.createElement(_components.BaseSvg, _extends({
          size: size,
          viewBoxSize: 24,
          fill: "none",
          className: (0, _classnames.default)('stroke-current', className)
        }, props), /*#__PURE__*/_react.default.createElement("path", {
          strokeLinecap: "round",
          strokeLinejoin: "round",
          d: "M19 4H5a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2ZM16 3v3M12 3v3M8 3v3M12 16h5"
        }), /*#__PURE__*/_react.default.createElement("path", {
          strokeLinecap: "round",
          strokeLinejoin: "round",
          d: "M8.634 15.116a1.25 1.25 0 1 1-1.768 1.768 1.25 1.25 0 0 1 1.768-1.768M12 11h5M8.634 10.116a1.25 1.25 0 1 1-1.768 1.768 1.25 1.25 0 0 1 1.768-1.768Z"
        }));
      }
    case 'shield':
      {
        return /*#__PURE__*/_react.default.createElement(_components.BaseSvg, _extends({
          width: "18",
          height: "20",
          className: (0, _classnames.default)('fill-current', className)
        }, props), /*#__PURE__*/_react.default.createElement("path", {
          stroke: "#497265",
          strokeWidth: "2",
          d: "M1 7.7V3.633L9 1.05l8 2.582V7.7c0 5.08-3.222 9.589-8 11.246A11.905 11.905 0 0 1 1 7.7Z"
        }), /*#__PURE__*/_react.default.createElement("path", {
          fill: "#497265",
          d: "M9 20V2L1 3.5V11c0 3.6 5.333 7.5 8 9Z"
        }));
      }
    case 'download':
      {
        return /*#__PURE__*/_react.default.createElement(_components.BaseSvg, _extends({
          size: size,
          className: (0, _classnames.default)('fill-current', className)
        }, props), /*#__PURE__*/_react.default.createElement("path", {
          d: "M20.7 16.5c0 2.3-1.9 4.2-4.2 4.2h-9c-2.3 0-4.2-1.9-4.2-4.2 0-.4.3-.7.7-.7.4 0 .7.3.7.7 0 1.6 1.3 2.9 2.9 2.9h8.9c1.6 0 2.9-1.3 2.9-2.9 0-.4.3-.7.7-.7.3 0 .6.3.6.7ZM16 11.6l-3.6 3.6c-.1.1-.2.1-.3.2h-.3c-.1 0-.2-.1-.3-.2L8 11.6c-.3-.3-.3-.7 0-1 .1-.1.3-.2.5-.2s.3.1.5.2l2.4 2.4V4c0-.4.3-.7.7-.7.4 0 .7.3.7.7v9l2.4-2.4c.3-.3.7-.3 1 0 .1.3.1.7-.2 1Z"
        }));
      }
    case 'star':
      {
        return /*#__PURE__*/_react.default.createElement(_components.BaseSvg, _extends({
          size: size,
          className: (0, _classnames.default)('fill-current', className)
        }, props), /*#__PURE__*/_react.default.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M18.1018 1.62732C18.4677 0.880522 19.5322 0.880593 19.8979 1.62744L24.6385 11.3072C24.7834 11.6031 25.0648 11.8086 25.3908 11.8567L36.0089 13.4207C36.8264 13.5411 37.1534 14.5448 36.5637 15.1237L28.8731 22.6718C28.6394 22.9012 28.5328 23.2304 28.5877 23.5533L30.4012 34.2074C30.5404 35.0254 29.6803 35.6474 28.9471 35.2588L19.4682 30.2361C19.1754 30.0809 18.8246 30.0809 18.5318 30.2361L9.05289 35.2588C8.31971 35.6474 7.45962 35.0254 7.59885 34.2074L9.41229 23.5533C9.46723 23.2304 9.36064 22.9012 9.12693 22.6718L1.4363 15.1236C0.846555 14.5448 1.17351 13.5411 1.99102 13.4206L12.6073 11.8567C12.9332 11.8086 13.2146 11.6032 13.3596 11.3073L18.1018 1.62732Z",
          stroke: "#497265",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }));
      }
    case 'pen':
      {
        return /*#__PURE__*/_react.default.createElement(_components.BaseSvg, _extends({
          size: size,
          viewBoxSize: 24,
          fill: "none",
          className: (0, _classnames.default)('stroke-current', className)
        }, props), /*#__PURE__*/_react.default.createElement("path", {
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "1.5",
          d: "m17.54 10.12-3.66-3.66"
        }), /*#__PURE__*/_react.default.createElement("path", {
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "1.5",
          d: "M6.251 21H3v-3.25c0-.266.105-.52.293-.708L16.627 3.707a.999.999 0 0 1 1.414 0l2.251 2.251a.999.999 0 0 1 0 1.414L6.958 20.707a.997.997 0 0 1-.707.293v0Z",
          clipRule: "evenodd"
        }));
      }
    case 'playlist':
      {
        return /*#__PURE__*/_react.default.createElement(_components.BaseSvg, _extends({
          size: size,
          viewBoxSize: 24,
          fill: "none",
          className: (0, _classnames.default)('stroke-current', className)
        }, props), /*#__PURE__*/_react.default.createElement("path", {
          fillRule: "evenodd",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "1.5",
          d: "m10.941 9.058 3.882 2.296a.75.75 0 0 1 0 1.291l-3.882 2.296a.75.75 0 0 1-1.132-.646v-4.59a.75.75 0 0 1 1.132-.647Z",
          clipRule: "evenodd"
        }), /*#__PURE__*/_react.default.createElement("path", {
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "1.5",
          d: "M18 21H6a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3Z",
          clipRule: "evenodd"
        }));
      }
    case 'drugs-pill-add-plus':
      {
        return /*#__PURE__*/_react.default.createElement(_components.BaseSvg, _extends({
          size: size,
          viewBoxSize: 24,
          fill: "none",
          className: (0, _classnames.default)('stroke-current', className)
        }, props), /*#__PURE__*/_react.default.createElement("path", {
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "1.5",
          d: "m13.318 13.318-5.71-5.71M16.785 12l.81-.81a4.798 4.798 0 0 0 0-6.785v0a4.798 4.798 0 0 0-6.785 0L4.405 10.81a4.798 4.798 0 0 0 0 6.785v0a4.798 4.798 0 0 0 6.785 0l.81-.81"
        }), /*#__PURE__*/_react.default.createElement("circle", {
          cx: "16.5",
          cy: "16.5",
          r: "4.5",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "1.5"
        }), /*#__PURE__*/_react.default.createElement("path", {
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "1.5",
          d: "M16.5 15v3M15 16.5h3"
        }));
      }
    case 'insurance-hands-heart':
      {
        return /*#__PURE__*/_react.default.createElement(_components.BaseSvg, _extends({
          size: size,
          viewBoxSize: 24,
          fill: "none",
          className: (0, _classnames.default)('stroke-current', className)
        }, props), /*#__PURE__*/_react.default.createElement("path", {
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "1",
          d: "M19 15.5v-4a1.5 1.5 0 0 1 3 0v6.556a4 4 0 0 1-.422 1.788L21 21"
        }), /*#__PURE__*/_react.default.createElement("path", {
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "1",
          d: "M14 21v-2.913a2 2 0 0 1 .4-1.2l1.678-2.238a1.624 1.624 0 0 1 2.447-.173v0c.57.57.635 1.475.15 2.121L17.623 18M5 15.5v-4a1.5 1.5 0 0 0-3 0v6.556a4 4 0 0 0 .422 1.788L3 21"
        }), /*#__PURE__*/_react.default.createElement("path", {
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "1",
          d: "M10 21v-2.913a2 2 0 0 0-.4-1.2l-1.678-2.238a1.624 1.624 0 0 0-2.447-.173v0a1.623 1.623 0 0 0-.15 2.121L6.377 18"
        }), /*#__PURE__*/_react.default.createElement("path", {
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "1",
          d: "M13.555 10.356A2.2 2.2 0 0 1 12 11v0a2.2 2.2 0 0 1-1.555-.644L7.81 7.721a2.765 2.765 0 0 1 3.911-3.911l.279.279.279-.279a2.765 2.765 0 0 1 3.911 3.911l-2.635 2.635Z",
          clipRule: "evenodd"
        }));
      }
    case 'chart-add':
      {
        return /*#__PURE__*/_react.default.createElement(_components.BaseSvg, _extends({
          size: size,
          viewBoxSize: 24,
          fill: "none",
          className: (0, _classnames.default)('stroke-current', className)
        }, props), /*#__PURE__*/_react.default.createElement("path", {
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "1.5",
          d: "M8.5 14v3M12.5 9v8M16.5 11v6M10 5h9.111C20.155 5 21 5.845 21 6.889v12.222A1.888 1.888 0 0 1 19.111 21H5.889A1.888 1.888 0 0 1 4 19.111V11M2 5h4M4 7V3"
        }));
      }
    case 'book-learn':
      {
        return /*#__PURE__*/_react.default.createElement(_components.BaseSvg, _extends({
          size: size,
          viewBoxSize: 24,
          fill: "none",
          className: (0, _classnames.default)('stroke-current', className)
        }, props), /*#__PURE__*/_react.default.createElement("path", {
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "1.5",
          d: "M12 20c-2.047-1.853-5.14-2.18-7.556-.981-.665.329-1.444-.12-1.444-.862V6.844c0-.607.275-1.19.756-1.56C6.245 3.369 9.753 3.597 12 5.97c2.247-2.373 5.755-2.601 8.244-.683.481.37.756.952.756 1.558v11.312c0 .742-.779 1.192-1.444.862C17.14 17.82 14.047 18.147 12 20v0Z",
          clipRule: "evenodd"
        }), /*#__PURE__*/_react.default.createElement("path", {
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "1.5",
          d: "M12 20V5.97"
        }));
      }
    case 'groups-heads':
      {
        return /*#__PURE__*/_react.default.createElement(_components.BaseSvg, _extends({
          size: size,
          viewBoxSize: 24,
          fill: "none",
          className: (0, _classnames.default)('stroke-current', className)
        }, props), /*#__PURE__*/_react.default.createElement("path", {
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "1.5",
          d: "M2 19c0-2.2 1.8-4 4-4h4c2.2 0 4 1.8 4 4M10.5 6c1.4 1.4 1.4 3.6 0 4.9-1.4 1.3-3.6 1.4-4.9 0C4.3 9.5 4.2 7.4 5.5 6c1.3-1.4 3.6-1.3 5 0M16 14h3c1.7 0 3 1.3 3 3M19.3 6.7c1 1 1 2.6 0 3.5-1 .9-2.6 1-3.5 0-.9-1-1-2.6 0-3.5.9-.9 2.5-.9 3.5 0"
        }));
      }
    case 'notification-bell':
      {
        return /*#__PURE__*/_react.default.createElement(_components.BaseSvg, _extends({
          size: size,
          viewBoxSize: 24,
          fill: "none",
          className: (0, _classnames.default)('stroke-current', className)
        }, props), /*#__PURE__*/_react.default.createElement("path", {
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "1.5",
          d: "M17.436 6a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5"
        }), /*#__PURE__*/_react.default.createElement("path", {
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "1.5",
          d: "M15.736 6.676a4.488 4.488 0 0 0-2.831-1.019h.002-1.813a4.53 4.53 0 0 0-4.531 4.531v2.797a2 2 0 0 1-.586 1.414l-.641.641a2 2 0 0 0-.586 1.414v0a1.89 1.89 0 0 0 1.89 1.89h10.721a1.89 1.89 0 0 0 1.89-1.89v0a2 2 0 0 0-.586-1.414l-.641-.641a2 2 0 0 1-.586-1.414v-1.986"
        }), /*#__PURE__*/_react.default.createElement("path", {
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "1.5",
          d: "M9.708 18.344v.365A2.292 2.292 0 0 0 12 21v0a2.292 2.292 0 0 0 2.292-2.292v-.365M13.833 5.751v-.918C13.833 3.821 13.013 3 12 3v0a1.833 1.833 0 0 0-1.833 1.833v.918"
        }));
      }
    case 'heart-check':
      {
        return /*#__PURE__*/_react.default.createElement(_components.BaseSvg, _extends({
          size: size,
          viewBoxSize: 24,
          fill: "none",
          className: (0, _classnames.default)('stroke-current', className)
        }, props), /*#__PURE__*/_react.default.createElement("path", {
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "1.5",
          d: "M12 5.711C12.689 4.905 13.881 4 15.696 4 18.87 4 21 6.98 21 9.755 21 15.556 13.778 20 12 20c-1.778 0-9-4.444-9-10.245C3 6.98 5.13 4 8.304 4c1.815 0 3.007.905 3.696 1.711Z",
          clipRule: "evenodd"
        }), /*#__PURE__*/_react.default.createElement("path", {
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "1.5",
          d: "m14.889 10.056-3.611 3.61L9.11 11.5"
        }));
      }
    case 'sprout':
      {
        return /*#__PURE__*/_react.default.createElement(_components.BaseSvg, _extends({
          size: size,
          viewBoxSize: 24,
          fill: "none",
          className: (0, _classnames.default)('stroke-current', className)
        }, props), /*#__PURE__*/_react.default.createElement("path", {
          d: "M12.1189 12.0002C13.8048 14.7645 14.5039 18.028 14.2678 20.497",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }), /*#__PURE__*/_react.default.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M14.1957 6.10212C12.3489 6.8857 11.487 9.01807 12.2705 10.8649C13.0541 12.7117 15.1865 13.5736 17.0333 12.7901C19.7575 11.6342 19.0069 8.00566 20.1897 6.45186C18.3628 5.38283 16.1345 5.25281 14.1957 6.10212V6.10212Z",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }), /*#__PURE__*/_react.default.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M7.38769 9.72027C9.21021 8.92035 11.2394 9.71094 11.92 11.4861C12.6007 13.2613 11.675 15.3488 9.85246 16.1487C7.16414 17.3287 5.2716 14.4031 3.40259 14.2224C3.97513 12.2161 5.45656 10.5425 7.38769 9.72027V9.72027Z",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }));
      }
    case 'profile-circle':
      {
        return /*#__PURE__*/_react.default.createElement(_components.BaseSvg, _extends({
          size: size,
          viewBoxSize: 40,
          fill: "none",
          className: (0, _classnames.default)('stroke-current', className)
        }, props), /*#__PURE__*/_react.default.createElement("path", {
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "1.5",
          d: "M20 35v0c-8.285 0-15-6.715-15-15v0c0-8.285 6.715-15 15-15v0c8.285 0 15 6.715 15 15v0c0 8.285-6.715 15-15 15Z",
          clipRule: "evenodd"
        }), /*#__PURE__*/_react.default.createElement("path", {
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "1.5",
          d: "M22.652 12.765a3.75 3.75 0 1 1-5.304 5.303 3.75 3.75 0 0 1 5.304-5.303M27.202 27.568c-.368-2.315-2.358-4.088-4.775-4.088h-4.853c-2.419 0-4.407 1.773-4.775 4.088"
        }));
      }
    case 'instagram':
      {
        return /*#__PURE__*/_react.default.createElement(_components.BaseSvg, _extends({
          size: size,
          viewBoxSize: 16,
          fill: "none",
          className: (0, _classnames.default)('stroke-current, fill-current', className)
        }, props), /*#__PURE__*/_react.default.createElement("path", {
          fillRule: "evenodd",
          d: "M8 0C5.827 0 5.555.01 4.702.048 3.85.087 3.269.222 2.76.42a3.921 3.921 0 0 0-1.417.923c-.445.444-.719.89-.923 1.417-.198.509-.333 1.09-.372 1.942C.01 5.555 0 5.827 0 8s.01 2.445.048 3.298c.039.852.174 1.433.372 1.942.204.526.478.973.923 1.417.444.445.89.719 1.417.923.509.198 1.09.333 1.942.372C5.555 15.99 5.827 16 8 16s2.445-.01 3.298-.048c.852-.039 1.433-.174 1.942-.372a3.922 3.922 0 0 0 1.417-.923c.445-.444.719-.89.923-1.417.198-.509.333-1.09.372-1.942C15.99 10.445 16 10.173 16 8s-.01-2.445-.048-3.298c-.039-.852-.174-1.433-.372-1.942a3.922 3.922 0 0 0-.923-1.417A3.921 3.921 0 0 0 13.24.42c-.509-.198-1.09-.333-1.942-.372C10.445.01 10.173 0 8 0Zm0 1.441c2.136 0 2.39.009 3.233.047.78.036 1.203.166 1.485.276.374.145.64.318.92.598.28.28.453.546.598.92.11.282.24.705.276 1.485.038.844.047 1.097.047 3.233s-.009 2.39-.047 3.233c-.036.78-.166 1.203-.276 1.485-.145.374-.318.64-.598.92-.28.28-.546.453-.92.598-.282.11-.705.24-1.485.276-.844.038-1.097.047-3.233.047s-2.39-.009-3.233-.047c-.78-.036-1.203-.166-1.485-.276a2.479 2.479 0 0 1-.92-.598 2.478 2.478 0 0 1-.598-.92c-.11-.282-.24-.705-.276-1.485-.038-.844-.047-1.097-.047-3.233s.009-2.39.047-3.233c.036-.78.166-1.203.276-1.485.145-.374.318-.64.598-.92.28-.28.546-.453.92-.598.282-.11.705-.24 1.485-.276.844-.038 1.097-.047 3.233-.047Zm0 9.226a2.667 2.667 0 1 1 0-5.334 2.667 2.667 0 0 1 0 5.334Zm0-6.775a4.108 4.108 0 1 0 0 8.216 4.108 4.108 0 0 0 0-8.216Zm4.27.798a.96.96 0 1 0 0-1.92.96.96 0 0 0 0 1.92Z",
          clipRule: "evenodd"
        }));
      }
    case 'medical-cross-in-rounded-square':
      {
        return /*#__PURE__*/_react.default.createElement(_components.BaseSvg, _extends({
          size: size,
          viewBoxSize: 24,
          fill: "none",
          className: (0, _classnames.default)('stroke-current', className)
        }, props), /*#__PURE__*/_react.default.createElement("g", {
          clipPath: "url(#a)"
        }, /*#__PURE__*/_react.default.createElement("path", {
          strokeLinecap: "round",
          strokeLinejoin: "round",
          d: "M16 2.5H8A5.5 5.5 0 0 0 2.5 8v8A5.5 5.5 0 0 0 8 21.5h8a5.5 5.5 0 0 0 5.5-5.5V8A5.5 5.5 0 0 0 16 2.5Z"
        })), /*#__PURE__*/_react.default.createElement("path", {
          strokeLinecap: "round",
          strokeLinejoin: "round",
          d: "M16.002 11.2a.8.8 0 0 0-.8-.8H13.6V8.798a.8.8 0 0 0-.8-.8H11.2a.8.8 0 0 0-.8.8v1.6H8.798a.8.8 0 0 0-.8.8V12.8a.8.8 0 0 0 .8.8h1.6v1.601a.8.8 0 0 0 .8.8H12.8a.8.8 0 0 0 .8-.8v-1.6h1.601a.8.8 0 0 0 .8-.8V11.2Z",
          clipRule: "evenodd"
        }), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
          id: "a"
        }, /*#__PURE__*/_react.default.createElement("path", {
          fill: "#fff",
          d: "M0 0h24v24H0z"
        }))));
      }
    case 'billing-sheet-circles-lines':
      {
        return /*#__PURE__*/_react.default.createElement(_components.BaseSvg, _extends({
          size: size,
          viewBoxSize: 24,
          fill: "none",
          className: (0, _classnames.default)('stroke-current', className)
        }, props), /*#__PURE__*/_react.default.createElement("path", {
          strokeLinecap: "round",
          strokeLinejoin: "round",
          d: "M19 4H5a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2ZM16 3v3M12 3v3M8 3v3M12 16h5"
        }), /*#__PURE__*/_react.default.createElement("path", {
          strokeLinecap: "round",
          strokeLinejoin: "round",
          d: "M8.634 15.116a1.25 1.25 0 1 1-1.768 1.768 1.25 1.25 0 0 1 1.768-1.768M12 11h5M8.634 10.116a1.25 1.25 0 1 1-1.768 1.768 1.25 1.25 0 0 1 1.768-1.768Z"
        }));
      }
    case 'chat-bubble-question-mark':
      {
        return /*#__PURE__*/_react.default.createElement(_components.BaseSvg, _extends({
          size: size,
          viewBoxSize: 24,
          fill: "none",
          className: (0, _classnames.default)('stroke-current', className)
        }, props), /*#__PURE__*/_react.default.createElement("path", {
          strokeLinecap: "round",
          strokeLinejoin: "round",
          d: "M3 11.291c0 2.683 1.42 5.045 3.599 6.534-.001.855.001 2.007.001 3.216l3.531-1.747a9.896 9.896 0 0 0 1.869.179c4.952 0 9-3.643 9-8.182 0-4.539-4.048-8.182-9-8.182s-9 3.643-9 8.182Z",
          clipRule: "evenodd"
        }), /*#__PURE__*/_react.default.createElement("path", {
          strokeLinecap: "round",
          strokeLinejoin: "round",
          d: "M11.9 12.328v-.207c0-.678.418-1.045.838-1.327.41-.276.821-.636.821-1.3a1.659 1.659 0 0 0-3.319-.001M11.898 14.667a.148.148 0 0 0-.15.15.15.15 0 1 0 .15-.15"
        }));
      }
    case 'profile-rounded-circle':
      {
        return /*#__PURE__*/_react.default.createElement(_components.BaseSvg, _extends({
          size: size,
          viewBoxSize: 24,
          fill: "none",
          className: (0, _classnames.default)('stroke-current', className)
        }, props), /*#__PURE__*/_react.default.createElement("g", {
          strokeLinecap: "round",
          strokeLinejoin: "round",
          clipPath: "url(#a)"
        }, /*#__PURE__*/_react.default.createElement("path", {
          d: "M16 2.5H8A5.5 5.5 0 0 0 2.5 8v8A5.5 5.5 0 0 0 8 21.5h8a5.5 5.5 0 0 0 5.5-5.5V8A5.5 5.5 0 0 0 16 2.5Z"
        }), /*#__PURE__*/_react.default.createElement("path", {
          d: "M12.118 11.706a2.353 2.353 0 1 0 0-4.706 2.353 2.353 0 0 0 0 4.706Z"
        }), /*#__PURE__*/_react.default.createElement("path", {
          d: "M12.118 7a2.353 2.353 0 0 1 0 4.706M16.235 17a2.353 2.353 0 0 0-2.353-2.353h-3.53A2.353 2.353 0 0 0 8 17"
        })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
          id: "a"
        }, /*#__PURE__*/_react.default.createElement("path", {
          d: "M0 0h24v24H0z"
        }))));
      }
    case 'location-pin':
      {
        return /*#__PURE__*/_react.default.createElement(_components.BaseSvg, _extends({
          size: size,
          viewBoxSize: 24,
          fill: "none",
          className: (0, _classnames.default)('stroke-current', className)
        }, props), /*#__PURE__*/_react.default.createElement("path", {
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "1.5",
          d: "M13.85 10.15a2.616 2.616 0 1 1-3.699 3.7 2.616 2.616 0 0 1 3.699-3.7M12 14.616V21"
        }), /*#__PURE__*/_react.default.createElement("path", {
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "1.5",
          d: "M8 20.05a8.88 8.88 0 0 1-2.364-1.686 9 9 0 0 1 0-12.728 9 9 0 0 1 12.728 0 9 9 0 0 1 0 12.728A8.88 8.88 0 0 1 16 20.05"
        }));
      }
    case 'payment-card':
      {
        return /*#__PURE__*/_react.default.createElement(_components.BaseSvg, _extends({
          size: size,
          viewBoxSize: 24,
          fill: "none",
          className: (0, _classnames.default)('stroke-current', className)
        }, props), /*#__PURE__*/_react.default.createElement("path", {
          stroke: "#325971",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "1.5",
          d: "M3 9h18M9.57 13H7"
        }), /*#__PURE__*/_react.default.createElement("path", {
          stroke: "#325971",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "1.5",
          d: "M18 19H6a3 3 0 0 1-3-3V8a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3Z",
          clipRule: "evenodd"
        }));
      }
    case 'session-notes':
      {
        return /*#__PURE__*/_react.default.createElement(_components.BaseSvg, _extends({
          size: size,
          viewBoxSize: 24,
          fill: "none",
          className: (0, _classnames.default)('stroke-current', className)
        }, props), /*#__PURE__*/_react.default.createElement("path", {
          strokeLinecap: "round",
          strokeLinejoin: "round",
          d: "M18 18v-3.5a1.5 1.5 0 0 1 1.5-1.5v0a1.5 1.5 0 0 1 1.5 1.5V19a3 3 0 0 1-3 3v0a3 3 0 0 1-3-3v-3M11 16H7M14 12H7M14 8H7M18 9V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h6"
        }));
      }
    default:
      {
        throw new Error((0, _utils.getErrorMessage)(type));
      }
  }
};
exports.Icon = Icon;